<script>
import * as am4core from '@amcharts/amcharts4/core';
import Multiselect from 'vue-multiselect';
import { searchZip, searchZip2 } from './worker-api';
import NumberInput from '@/components/NumberInput';
import crypto from 'crypto';
import axios from 'axios';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { scrollIntoView } from 'seamless-scroll-polyfill';
am4core.useTheme(am4themes_animated);
const R = require('ramda'); //todo swap ramda calls to lodash since we need lodash anyway for debounce
import _ from 'lodash';
import Navbar from '@/Navbar2';
import budgetComponent from '@/budgetChart/budgetComponent';
import transformer_38 from '@/transformers/transformer_new';
import common_monthly from '@/transformers/common_monthly';
import common_monthly_short from '@/transformers/common_monthly_short';
import transformer_category from '@/transformers/transformer_category';
import CoreExpenseCategories from '@/CoreExpenseCategories/CoreCategories.vue';
import EliminateCategory from '@/EliminateCategory/EliminateCategory.vue';
import ChatGptList from '@/components/ChatGptList';
import sidebar from '@/Sidebar/sidebar';
import howto from '@/molecules/howto';
import zip_codes from '@/data/zip_codes.json';
import state_gross from '@/data/state_gross_up.json';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { new_api } from '../auth_config.json';
import Stepform from './StepForm/stepform.vue';
import INIT from './initial';
import { csv_category } from './transformers/csv_category';

function initialState() {
  let token;
  try {
    var cookieArr = document.cookie.split(';');
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split('=');
      if ('userDetail' == cookiePair[0].trim()) {
        token = decodeURIComponent(cookiePair[1]);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
  }
  return {
    access_token: token,
    zip_codes: zip_codes,
    state_gross: state_gross,
    common_monthly,
    filteredZipCodes: [],
    senderEmail: '',
    ...INIT,
  };
}
export default {
  name: 'landing-app',
  components: {
    ChatGptList,
    Navbar,
    Multiselect,
    Stepform,
    budgetComponent,
    sidebar,
    NumberInput,
    CoreExpenseCategories,
    EliminateCategory,
    howto,
    VueSlider,
  },
  data() {
    return initialState();
  },
  computed: {
    totalExpenses() {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      const sum = this.net_amount.reduce((partialSum, a) => partialSum + parseFloat(a.net || 0), 0);
      var monthly_cash_excess =
        (this.lending_score && this.lending_score.elements && this.lending_score.elements.cash_excess / 12) || 0;
      const total = sum - monthly_cash_excess;
      return formatter.format(total);
    },
    // filteredZipCodes() {
    //   const searchTextLowerCase = this.searchText.toLowerCase().trim();
    //   return this.zip_codes.filter((option) => {
    //     const zipCode = option['Zip Code'].toLowerCase();
    //     return zipCode.startsWith(searchTextLowerCase);
    //   });
    // },
    returnDebtPeer() {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      return (
        this.filtered_barchart &&
        this.filtered_barchart.length > 0 &&
        formatter.format(parseInt(this.filtered_barchart[3].peer_monthly))
      );
    },
    zip() {
      return this.selectedZip ? this.selectedZip['Zip Code'] : '';
    },
    userId() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data
          ? this.$cookies.get('userDetail').data.id
          : null) || this.data
      );
    },
    otherAllDebs() {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      const sum = [
        this.creditDebtPayment,
        this.studentLoan,
        this.homeEquityPayment,
        this.alimonyPayments,
        this.childSupportPayments,
        this.estimatedTaxPayments,
        this.otherDebtPayments,
      ]
        .filter(Boolean)
        .reduce((a, b) => parseInt(this.unmaskMoneyValue(a)) + parseInt(this.unmaskMoneyValue(b)), 0);

      return formatter.format(sum);
    },
    monthlyBillCount() {
      return this.filtered_barchart
        ? this.filtered_barchart.filter((item, i) => i > 4 && item.isActive && common_monthly.includes(item.category))
          .length
        : 0;
    },
    eleMonthlyBillCount() {
      return this.filtered_barchart
        ? this.filtered_barchart.filter((item, i) => i > 4 && !item.isActive && common_monthly.includes(item.category))
          .length
        : 0;
    },
    eleOtherBillCount() {
      return this.filtered_barchart
        ? this.filtered_barchart.filter((item, i) => i > 4 && !item.isActive && !common_monthly.includes(item.category))
          .length
        : 0;
    },
    netAmountInput() {
      const sum = this.net_amount.reduce((partialSum, a) => partialSum + parseFloat(a.net || 0), 0);
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    returnScoreLending() {
      const saving =
        Array.isArray(this.filtered_barchart) && this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      var monthly_cash_excess = (saving && saving.peer_monthly) || 0;
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(a.net || 0),
        0
      );
      var net_value = Math.round(sum);
      return this.lending_score && ((monthly_cash_excess / net_value + 0.8) * 100).toFixed(1);
    },
    returnScore() {
      return (
        this.scores &&
        this.scores.breakeven &&
        (parseFloat(this.scores.breakeven) > 100
          ? parseFloat(this.scores.breakeven)
          : parseFloat(this.scores.breakeven))
      );
    },
    saving_peer_amount() {
      const saving = this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      if (saving) {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        });
        return formatter.format(saving.peer_monthly);
      }
      return 0;
    },
    is_homeowner_value() {
      if (this.is_homeowner === '') {
        return null;
      } else {
        return this.is_homeowner === true || this.is_homeowner === 'true';
      }
    },
    savings_value() {
      if (this.savings_input_value) {
        let val = parseFloat(this.unmaskMoneyValue(this.savings_input_value));
        let is_percentage = val > 0 && val < 1;
        return is_percentage ? this.monthly_take_home * val : val;
      } else {
        return null;
      }
    },
    debt_value() {
      return this.debt_input_value ? parseFloat(this.unmaskMoneyValue(this.debt_input_value)) : null;
    },
    health_insurance_value() {
      return this.health_insurance_input_value
        ? parseFloat(this.unmaskMoneyValue(this.health_insurance_input_value))
        : null;
    },
    mortgage_and_rent_value() {
      return this.mortgage_and_rent_input_value
        ? parseFloat(this.unmaskMoneyValue(this.mortgage_and_rent_input_value))
        : null;
    },
    vehicle_purchase_and_lease_value() {
      return this.vehicle_purchase_and_lease_input_value
        ? parseFloat(this.unmaskMoneyValue(this.vehicle_purchase_and_lease_input_value))
        : null;
    },
    scores_ready() {
      return this.scores != null && !this.api_updates_pending;
    },
    savings_grade() {
      return this.scores_ready ? this.score_to_grade(this.scores.saving) : '';
    },
    savings_grade_css_classes() {
      return this.scores_ready ? this.grade_to_css_class(this.savings_grade) : {};
    },
    breakeven_grade() {
      return this.lending_score ? this.score_to_grade(this.lending_score.elements.cash_excess / 12) : '';
    },
    breakeven_grade_css_classes() {
      return this.scores_ready ? this.grade_to_css_class(this.breakeven_grade) : {};
    },
    saving_peer_amount_grade() {
      const saving = this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      if (this.scores_ready && saving) {
        return this.score_to_grade(saving.peer_monthly);
      }
      return '';
    },
    saving_peer_amount_css_classes() {
      return this.scores_ready ? this.grade_to_css_class(this.saving_peer_amount_grade) : {};
    },
    lending_grade() {
      return this.scores_ready ? this.score_to_grade(this.scores.lending) : '';
    },
    lending_grade_css_classes() {
      return this.scores_ready ? this.grade_to_css_class(this.lending_grade) : {};
    },
    monthly_take_home_input_value_check() {
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        0
      );
      return Math.round(sum / 12);
    },
    monthly_take_home_input_value() {
      const sum = this.net_amount.reduce((partialSum, a) => partialSum + parseFloat(a.gross || 0), 0);
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      // this.recalculateNet(Math.round(sum));
      return formatter.format(Math.round(sum));
    },
    monthly_take_home() {
      return this.monthly_take_home_input_value
        ? parseFloat(this.unmaskMoneyValue(this.monthly_take_home_input_value))
        : null;
    },
    monthly_take_home_net() {
      return this.netAmountInput ? parseFloat(this.unmaskMoneyValue(this.netAmountInput)) : null;
    },
    lending_score_cash_excess_formattedNon() {
      if (this.lending_score == null) {
        return '';
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      var monthly_cash_excess = (this.lending_score.elements.cash_excess / 12).toFixed(0);
      return formatter.format(monthly_cash_excess < 0 ? 0 : monthly_cash_excess);
    },

    lending_score_cash_excess_formatted() {
      if (this.lending_score == null) {
        return '';
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      var monthly_cash_excess = this.lending_score.elements.cash_excess / 12;
      if (!this.investmentBalanceFixed) {
        this.investmentBalance = monthly_cash_excess < 0 ? '$0' : formatter.format(monthly_cash_excess);
      }
      return formatter.format(monthly_cash_excess);
    },
    selected_transformer() {
      return transformer_38;
    },
  },
  watch: {
    activeTab: {
      handler(val) { },
      deep: true,
      immediate: true,
    },
    netAmountInput() {
      if (this.checkForValidate()) {
        this.updateCharts();
      }
    },
    income_method_val(val) {
      this.net_amount = [
        {
          amount: '$0',
          freq: 12,
        },
      ];
    },
    occupations_val: {
      handler(val) {
        if (val && this.annual_gross_salary_level_val) {
          const selectedOccupation = this.occupations.find((item) => item.id == val);
          if (this.annual_gross_salary_level_val == 1) {
            this.occupationGrossIncome = selectedOccupation.low;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }

          this.recalculateNet(Math.round(sum / 12));
        }
      },
      deep: true,
      immediate: true,
    },
    annual_gross_salary_level_val: {
      handler(val) {
        if (this.occupations_val && val) {
          const selectedOccupation = this.occupations.find((item) => item.id == this.occupations_val);
          if (val == 1) {
            this.occupationGrossIncome = selectedOccupation.low;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }
          this.grossOrNet = 'gross';
          const sum = this.net_amount.reduce(
            (partialSum, a) => partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
            0
          );
          this.recalculateNet(Math.round(sum / 12));
        }
      },
      deep: true,
      immediate: true,
    },
    async grossOrNet(val) {
      this.is_typing = true;
      this.api_updates_pending = true;
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        0
      );
      this.recalculateNet(Math.round(sum / 12));
      setTimeout(() => {
        if (this.checkForValidate()) {
          this.updateCharts();
        }
      }, 2500);
      localStorage.setItem('grossOrNet', val);
    },
    async lending_score_cash_excess_formattedNonFormat() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateChartsCached(); // if calculation issue occur replace this function
      }
    },
    access_token: {
      handler() {
        if (this.access_token) {
          this.loadUser();
        }
      },
      deep: true,
      immediate: true,
    },
    async sortBy() {
      await this.changeFilter(this.sortDefault);
    },
    async monthly_take_home() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async household_members() {
      if (this.household_members < 1) {
        return false;
      }
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async age() {
      if (this.age < 18) {
        return false;
      }
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async zip(newValue) {
      if (newValue && typeof newValue === 'object' && newValue['Zip Code']) {
        this.zip = newValue['Zip Code'];
      }
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async is_homeowner(val) {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async user_name() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async user_email() {
      this.visibleCashHealthAnalysis = true;
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async monthly_take_home_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async savings_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async savings_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async debt_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async debt_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async mortgage_and_rent_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async mortgage_and_rent_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async health_insurance_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async health_insurance_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async vehicle_purchase_and_lease_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async vehicle_purchase_and_lease_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async selected_category() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async chart_range() {
      if (this.chart_range === 'week') {
        this.pie_chart.series.template.dataFields.value = 'weekly';
        // this.pie_chart2.series.template.dataFields.value = "weekly";
      } else if (this.chart_range === 'month') {
        this.pie_chart.series.template.dataFields.value = 'monthly';
        // this.pie_chart2.series.template.dataFields.value = "monthly";
      } else {
        this.pie_chart.series.template.dataFields.value = 'yearly';
        // this.pie_chart2.series.template.dataFields.value = "yearly";
      }
    },
  },
  async mounted() {
    // Assuming you fetch the image URL asynchronously
    this.fetchImageUrl();

    // const loggedUser = this.checkLoggedIn(); //;
    // if (!loggedUser) {
    //   window.location.href = "https://biz.spendid.io/login";
    // }
    if (this.$route.query.onboard) {
      this.resetDefault(true);
      this.$router.replace({ query: null });
    }
    let headers = {
      key: this.key,
    };

    let storedData;
    let userData;
    let assessment;


    if (this.$route.query.existing) {
      this.$router.replace({ query: null });
      this.$emit("stepEnable", false);

      let headers_last = {
        Authorization: "Bearer " + this.$cookies.get('userDetail').data.access_token,
      };
      this.$http
        .get(`${new_api}/get-last-data-By-user`, { headers: headers_last })
        .then((response) => {
          this.fillAutoData(response)
        });
    }

    try {
      storedData = await this.$cookies.get('storedData');
      userData = await this.$cookies.get('userDetail');
      assessment = await this.$cookies.get('assessmentId');
      let stepEnabled = await this.$cookies.get('stepEnable');
      const grossOrNet = (await localStorage.getItem('grossOrNet')) ? localStorage.getItem('grossOrNet') : 'gross';
      this.grossOrNet = grossOrNet;
      this.getOccupation();
      if (stepEnabled && stepEnabled == 'true') {
        this.stepEnable = true
      } else {
        this.stepEnable = false
      }

      if (storedData) {
        if (storedData.age) {
          // this.stepEnable = false;
          this.visibleOtherExpCat = true;
        } else {
          // this.stepEnable = true;
        }
        if (storedData.age) {
          this.setData(storedData);
        }
      } else {
        // this.stepEnable = true;
      }

      this.dark = await (localStorage.getItem('mode') === null
        ? false
        : localStorage.getItem('mode') === 'false'
          ? false
          : true);
      if (this.dark) {
        var element = document.querySelector('body');
        element.classList.add('darkmode');
      } else {
        var element = document.querySelector('body');
        element.classList.remove('darkmode');
      }
    } catch (e) {
      this.dark = true;
      var element = document.querySelector('body');
      element.classList.add('darkmode');
    }
    window.scrollTo(0, 0);
    this.api_updates_pending = true;
    const { demographics, budget, scores, lendingScore } = await this.callAPIs();

    this.barChart = this.mergeResponses(demographics, budget);
    const fullData = this.mergeResponses(demographics, budget);
    this.filtered_barchart = fullData.map((v) => Object.assign(v, { isActive: true }));

    const chart1Data = budget.map((item) => ({
      ...item,
      type: transformer_category[item.category_type].type,
    }));
    const chart2Data = demographics.map((item, k) => ({
      ...item,
      type: transformer_category[budget[k].category_type].type,
    }));
    const chart1 = this.getPieChartData(chart1Data);
    const chart2 = this.getPieChartData(chart2Data);
    this.getOccupation();
    this.chart3Data = chart1;
    this.chart4Data = chart2;
    this.pie_chart3 = this.createPieChart(chart1, 'piechart3', '%');
    this.pie_chart4 = this.createPieChart(chart2, 'piechart4', '%appsk');
    this.speed_chart = this.createSpeedChart(scores.breakeven);
    const standardChart = [
      {
        category: 'Needs',
        monthly: 50,
      },
      {
        category: 'Wants',
        monthly: 30,
      },
      {
        category: 'Financial Goals',
        monthly: 20,
      },
    ];

    this.pie_chart5 = this.createPieChart(standardChart, 'piechart5', '%');
    this.bar_chart = this.createBarChart(this.barChart);
    setTimeout(() => {
      this.openProjectedGrowth();
    }, 400);
    this.pie_chart = this.createPieChart(budget, 'piechart');
    this.sortBy = 'category';
    this.changeFilter(true);
    this.scores = scores;
    this.lending_score = lendingScore;
    this.api_updates_pending = false;
    this.resetUserActivityTimeout();
    window.addEventListener('mousemove', this.resetUserActivityTimeout);
    window.addEventListener('scroll', this.resetUserActivityTimeout);
    window.addEventListener('keydown', this.resetUserActivityTimeout);
    window.addEventListener('resize', this.resetUserActivityTimeout);
  },
  destroyed() {
    window.removeEventListener('mousemove', this.resetUserActivityTimeout);
    window.removeEventListener('scroll', this.resetUserActivityTimeout);
    window.removeEventListener('keydown', this.resetUserActivityTimeout);
    window.removeEventListener('resize', this.resetUserActivityTimeout);
  },
  beforeDestroy() {
    if (this.pie_chart) {
      this.pie_chart.dispose();
    }
    if (this.pie_chart2) {
      this.pie_chart2.dispose();
    }
    if (this.pie_chart3) {
      this.pie_chart3.dispose();
    }
    if (this.pie_chart4) {
      this.pie_chart4.dispose();
    }
    if (this.pie_chart5) {
      this.pie_chart5.dispose();
    }
    if (this.bar_chart) {
      this.bar_chart.dispose();
    }
    if (this.speed_chart) {
      this.speed_chart.dispose();
    }
  },

  methods: {

    downloadCSV(email) {
      if (this.senderEmail == '' && email) {
        this.$toasted.clear();
        this.$toasted.success('Email is required', {
          position: 'bottom-center',
          duration: 3000,
          className: 'inline-toast',
        });
        setTimeout(() => {
          this.toasted = '';
        }, 3000);
        return true;
      }
      let csvContent = email ? '' : 'data:text/csv;charset=utf-8,';
      csvContent += 'SPENDiD Expense Category, YNAB, Rocket Money, Monarch Money, Empower, Goodbudget, PocketGuard, Quicken Simplifi, Honeydue, Every Dollar, Zeta, Tiller Money, Spendee, MoneyPatrol, Budget Amount, Peer Amount\n'; // Header

      this.filtered_barchart.forEach(row => {
        try {
          if (csv_category[row.category_type]) {
            csvContent += `${csv_category[row.category_type].cat1},${csv_category[row.category_type].cat2}, ${csv_category[row.category_type].cat3},${csv_category[row.category_type].cat4},${csv_category[row.category_type].cat5},${csv_category[row.category_type].cat6},${csv_category[row.category_type].cat7},${csv_category[row.category_type].cat8},${csv_category[row.category_type].cat9},${csv_category[row.category_type].cat10},${csv_category[row.category_type].cat11},${csv_category[row.category_type].cat12},${csv_category[row.category_type].cat13},${csv_category[row.category_type].cat14},${row.user_monthly}, ${row.peer_monthly}\n`;
          }
        } catch (error) {
          // console.log(error)
        }
        // console.log(csvContent)
      });

      if (email) {
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const formData = new FormData();
        formData.append('file', blob, 'data.csv'); // Append the blob as a file
        formData.append('email', this.senderEmail); // Append the blob as a file
        formData.append('type', 'app'); // Append the blob as a file

        // Send the CSV to an API via POST request
        fetch('https://biz.spendid.io/api/send-csv', {
          method: 'POST',
          body: formData,
          headers: {
            // Optional: Add other headers if needed (e.g., API key, authorization)
          }
        })
          .then(response => {
            if (response.ok) {
              this.senderEmail = '';
              this.$toasted.success('File Sent successfully', {
                position: 'bottom-center',
                duration: 3000,
                className: 'inline-toast',
              });
            } else {
              // console.error('Failed to upload file', response.statusText);
            }
          })
          .catch(error => {
            // console.error('Error uploading file:', error)
          });
      } else {
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'data.csv');
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
      }

    },
    async handleSearchChange(searchQuery) {

      this.filteredZipCodes = await searchZip2(searchQuery);
      if (searchQuery.length !== 5) this.dropdownOpen = true;
      if (searchQuery.length === 5) {
        this.selectedZip = await searchZip(searchQuery);
        if (this.selectedZip) {
          this.zipCode = searchQuery;
          this.dropdownOpen = false;
        }
      }
      this.searchText = searchQuery;
    },
    selectZip(zip) {
      this.selectedZip = zip;
      this.zipCode = zip['Zip Code'];
      this.dropdownOpen = false;
    },
    showDropdown(event) {
      if (this.zipCode === 5) {
        return;
      } else {
        this.dropdownOpen = true;
      }
    },
    hideDropdown(event) {
      const clickedInsideInput = event.relatedTarget === this.$refs.input;
      const clickedInsideDropdown = event.relatedTarget === this.$refs.dropdown;
      if (!clickedInsideInput && !clickedInsideDropdown) {
        this.dropdownOpen = false;
      }
    },
    onOwnerChange(event) {
      this.is_homeowner = event.target.value == 'true';
    },
    async instantReport() {
      const state =
        zip_codes.find((item) => item['Zip Code'] === this.zip) &&
        state_gross.find((it) => it.abbreviation === zip_codes.find((item) => item['Zip Code'] === this.zip)['State'])
          .state;
      const city =
        zip_codes.find((item) => item['Zip Code'] === this.zip) &&
        zip_codes.find((item) => item['Zip Code'] === this.zip)['City'];
      const occu = this.occupationAIText.map((item) => item.title).join(', ');

      const comparison = this.barChart;
      const _this = this;
      const gapData = comparison.map((item) => {
        return { ...item, gap: item.user_monthly - item.peer_monthly };
      });
      var dataArray = Object.keys(_this.changedValues).map(function (k) {
        if (_this.changedValues[k]) {
          return k;
        }
      });
      const mainData = gapData
        .filter((item) => item.category !== 'Amount to Savings Each Period')
        .sort((a, b) => (a.gap > b.gap ? -1 : b.gap > a.gap ? 1 : 0))
        .filter((item) => item.gap > 0 && dataArray.includes(item.category_type));
      let dat = '';
      mainData.forEach((item) => {
        dat += `${item.category} :  ${item.gap}`;
      });

      const promptRes = await this.$http.get('https://admin.spendid.io/api/prompt', {});
      const promptTxt = promptRes.data.data.prompt;


      const promptData = {
        ZIP: this.zip,
        CITY: city,
        STATE: state,
        OCCUPATION: occu,
        AGE: this.age,
        HOMEOWNER: this.is_homeowner ? 'Own' : 'Rent',
        MEMBER: this.household_members,
        LENDING_SCORE: this.lending_score_cash_excess_formatted,
        SAVING_PEER_SCORE: this.saving_peer_amount,
        SCORE_LENDING_PEER: this.returnScoreLending || 0,
        SCORE: this.returnScore || 0,
        DATA: dat
      };

      const prompt = promptTxt
        .replace("[ZIP]", promptData.ZIP)
        .replace("[CITY]", promptData.CITY)
        .replace("[STATE]", promptData.STATE)
        .replace("[OCCUPATION]", promptData.OCCUPATION)
        .replace("[AGE]", promptData.AGE)
        .replace("[HOMEOWNER]", promptData.HOMEOWNER)
        .replace("[MEMBER]", promptData.MEMBER)
        .replace("[LENDING_SCORE]", promptData.LENDING_SCORE)
        .replace("[SAVING_PEER_SCORE]", promptData.SAVING_PEER_SCORE)
        .replace("[SCORE_LENDING_PEER]", promptData.SCORE_LENDING_PEER)
        .replace("[SCORE]", promptData.SCORE)
        .replace("[DATA]", promptData.DATA);

      const data = {
        title: prompt,
        largePrompt: true,
        predicted: 0,
        peer: 0,
        type: 'Major',
        age: this.age,
        zip: this.zip,
        size: this.household_members,
      };
      this.uses = data;
      this.modalShow = true;
    },
    fetchImageUrl() {
      // Construct the image URL with dynamic parameters
      const imageUrl = `https://biz.spendid.io/api/get-image/${this.userId}?ver=${Math.random()}`;
      // Set the imageUrl data property
      this.imageUrl = imageUrl;
    },
    submitDebtNo() {
      this.month_debs = 'no';

      const rest = this.changedValues;
      rest['other_debt_payments'] = 0;
      this.changedValues = rest;
      this.debt_input_value = '0';

      this.$refs['other-debt'].hide();
      setTimeout(() => {
        this.updateCharts();
      }, 400);
    },
    submitDebt() {
      this.month_debs = 'yes';
      const debt = [
        this.otherDebtPayments,
        this.creditDebtPayment,
        this.studentLoan,
        this.alimonyPayments,
        this.homeEquityPayment,
        this.childSupportPayments,
        this.estimatedTaxPayments,
      ]
        .filter(Boolean)
        .reduce((partialSum, a) => parseInt(this.unmaskMoneyValue(partialSum)) + parseInt(this.unmaskMoneyValue(a)), 0);
      const rest = this.changedValues;
      rest['other_debt_payments'] = debt ? parseInt((debt ? debt : 0) * 12) : 0;
      this.changedValues = rest;
      this.debt_input_value = `$${debt}` || '0';
      this.$refs['other-debt'].hide();
      setTimeout(() => {
        this.updateCharts();
      }, 400);
      setTimeout(() => {
        const el = document.getElementById(`other_debt_payments_card`);
        var options = {
          easing: 'ease-in',
          lazy: false,
          offset: -170,
          force: true,
          cancelable: true,
          onStart: function (element) {
            // scrolling started
          },
          onDone: function (element) {
            // scrolling is done
          },
          onCancel: function () {
            // scrolling has been interrupted
          },
          x: false,
          y: true,
        };
        this.$scrollTo(el, 500, options);
      }, 200);
    },
    openOtherDebt() {
      this.otherDebtPayments = this.otherDebtPayments ? parseInt(this.unmaskMoneyValue(this.otherDebtPayments)) : '';
      this.creditDebtPayment = this.creditDebtPayment ? parseInt(this.unmaskMoneyValue(this.creditDebtPayment)) : '';
      this.studentLoan = this.studentLoan ? parseInt(this.unmaskMoneyValue(this.studentLoan)) : '';
      this.alimonyPayments = this.alimonyPayments ? parseInt(this.unmaskMoneyValue(this.alimonyPayments)) : '';
      this.homeEquityPayment = this.homeEquityPayment ? parseInt(this.unmaskMoneyValue(this.homeEquityPayment)) : '';
      this.childSupportPayments = this.childSupportPayments
        ? parseInt(this.unmaskMoneyValue(this.childSupportPayments))
        : '';
      this.estimatedTaxPayments = this.estimatedTaxPayments
        ? parseInt(this.unmaskMoneyValue(this.estimatedTaxPayments))
        : '';
      this.$refs['other-debt'].show();
    },
    numberValueChange2(arg, arg2) {
      var self = this;
      self[arg2] = arg;
    },
    scrollToSection(val) {
      if (val == 'Your Profile') {
        setTimeout(() => {
          const el = document.getElementById(`my-profile-page`);
          var options = {
            easing: 'ease-in',
            lazy: false,
            offset: -170,
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
            },
            onDone: function (element) {
              // scrolling is done
            },
            onCancel: function () {
              // scrolling has been interrupted
            },
            x: false,
            y: true,
          };
          this.$scrollTo(el, 500, options);
        }, 200);
      } else if (val == 'Income') {
        setTimeout(() => {
          const el = document.getElementById(`my-income-page`);
          var options = {
            easing: 'ease-in',
            lazy: false,
            offset: -170,
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
            },
            onDone: function (element) {
              // scrolling is done
            },
            onCancel: function () {
              // scrolling has been interrupted
            },
            x: false,
            y: true,
          };
          this.$scrollTo(el, 500, options);
        }, 200);
      } else if (val == 'Your Major Expenses') {
        setTimeout(() => {
          const el = document.getElementById(`my-expenses-page`);
          var options = {
            easing: 'ease-in',
            lazy: false,
            offset: -170,
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
            },
            onDone: function (element) {
              // scrolling is done
            },
            onCancel: function () {
              // scrolling has been interrupted
            },
            x: false,
            y: true,
          };
          this.$scrollTo(el, 500, options);
        }, 200);
      } else if (val == 'Your Result') {
        setTimeout(() => {
          const el = document.getElementById(`my-result-page`);
          var options = {
            easing: 'ease-in',
            lazy: false,
            offset: -170,
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
            },
            onDone: function (element) {
              // scrolling is done
            },
            onCancel: function () {
              // scrolling has been interrupted
            },
            x: false,
            y: true,
          };
          this.$scrollTo(el, 500, options);
        }, 200);
      }
    },
    toggleSidebar() { },

    async newIntroStart() {
      if (this.$cookies.get('dontshow')) {
        return true;
      }
      const _this = this;
      const { introJs } = require('intro.js');
      introJs()
        .setOptions({
          steps: [
            {
              intro: `Great! You’ve completed the basic onboarding requirements
                  and can see your “unadjusted”Results here.`,
            },
            {
              element: document.querySelector('#nav-item-expense'),
              intro: `Next, you’ll want to customize some Expense categories
with dollar amounts you know are more accurate for you.`,
            },
            {
              element: document.querySelector('.your-opportunities-card'),
              intro: `After editing your expenses, the data in your Results may have changed.
Your next question is probably, “What now?” Focus here first on
categories where your amount is higher than your Peers. Just click on a bar
in the Areas of Improvement section.
`,
              tooltipPosition: 'right',
            },
          ],
          dontShowAgain: true,
          overlayOpacity: 0,
          highlightClass: 'newIntroStart',
          dontShowAgainLabel: "Don't show again",
          skipLabel: "Don't show again",
        })
        .onskip(function () {
          // eslint-disable-next-line no-empty
          if (this._currentStep === this._introItems.length - 1) {
          } else {
            _this.$cookies.set('dontshow', true, '1d');
          }
        })
        .oncomplete(function () { })
        .onexit(function () { })
        .onbeforechange(function (targetElement) { })
        .start();
    },
    async introStart() {
      this.oldData = await this.$cookies.get('storedData');
      const { introJs } = require('intro.js');
      const _this = this;
      this.age = 26;
      this.selectedZip = {
        'Zip Code': '32550',
        TEST: 32550,
        City: 'MIRAMAR BEACH',
        State: 'FL',
        Latitude: 30.3915,
        Longitude: -86.3511,
        Population: 5867,
      };
      this.zipCode = '32550';
      this.is_homeowner = false;
      this.occupationAIText = [];
      (this.net_amount = [
        {
          amount: '6000',
          freq: 12,
          manual: '2',
          occupation: null,
          level: null,
          grossOrNet: 'net',
          net: 6000,
          gross: 7895,
        },
      ]),
        (this.inDemo = true);

      _this.activeTab = ['Your Profile', 'Income', 'Other Discretionary Expenses'];
      setTimeout(() => {
  let steps = [
    {
      element: document.querySelector('.my-profile-page'),
      intro: `Complete the simple Profile inputs`,
    },
    {
      element: document.querySelector('.my-income-page'),
      intro: `Input Gross or Net Income from all sources, or use the Occupation to Income selector`,
    },
    {
      element: document.querySelector('.major-expenses-card'),
      intro: `Peer amounts for Major Expenses are pre-populated, which you can accept or edit`,
      tooltipPosition: 'right',
    },
    {
      element: document.querySelector('#other_debt_payments_card'),
      intro: `If you have Other Debt Payments, click Yes and add in the list provided`,
    },
    {
      element: document.querySelector('.monthly-bills-card'),
      intro: `You can edit or remove any common Monthly Bills or Other Expense categories`,
      tooltipPosition: 'right',
    },
    {
      element: document.querySelector('.budget-health-score-card'),
      intro: `This is your easy-to-understand Budget Health Score`,
    },
    {
      element: document.querySelector('.your_monthly_saving_ability'),
      intro: `Your Predicted Monthly Saving Ability based on your scenario inputs`,
    },
    {
      element: document.querySelector('.projected-investment-header-card'),
      intro: `Even pre-tax Projected Savings Growth to Age 65`,
    },
    {
      element: document.querySelector('.budget-modal-category-card'),
      intro: `See how your budget scenario aligns with the 50-30-20 suggested model`,
    },
    {
      element: document.querySelector('.your-budget-analysis'),
      intro: `Click here to see a simple summary of your situation and how you can improve`,
    },
    {
      element: '#export-csv-file',
      intro: `Click here to export pre-categorized budget data to a .csv file for use in other applications`,
    },
  ];

  // ✅ **Modify Steps for Mobile Devices**
  if (window.innerWidth <= 768) {
    steps = [
    {
      element: document.querySelector('.my-profile-page'),
      intro: `Complete the simple Profile inputs`,
    },
    {
      element: document.querySelector('.my-income-page'),
      intro: `Input Gross or Net Income from all sources, or use the Occupation to Income selector`,
    },
    {
      element: document.querySelector('.major-expenses-card'),
      intro: `Peer amounts for Major Expenses are pre-populated, which you can accept or edit`,
      tooltipPosition: 'right',
    },
    {
      element: document.querySelector('#other_debt_payments_card'),
      intro: `If you have Other Debt Payments, click Yes and add in the list provided`,
    },
    {
      element: document.querySelector('.monthly-bills-card'),
      intro: `You can edit or remove any common Monthly Bills or Other Expense categories`,
      tooltipPosition: 'right',
    },
    {
      element: document.querySelector('.budget-health-score-card'),
      intro: `This is your easy-to-understand Budget Health Score`,
    },
    {
      element: document.querySelector('.your_monthly_saving_ability'),
      intro: `Your Predicted Monthly Saving Ability based on your scenario inputs`,
    },
    {
      element: document.querySelector('.projected-investment-header-card'),
      intro: `Even pre-tax Projected Savings Growth to Age 65`,
    },
    {
      element: document.querySelector('.budget-modal-category-card'),
      intro: `See how your budget scenario aligns with the 50-30-20 suggested model`,
    },
    {
      element: document.querySelector('.your-budget-analysis'),
      intro: `Click here to see a simple summary of your situation and how you can improve`,
    },  
    {
        element: '#mail-csv-file',
        intro: `Click here to export pre-categorized budget data to a .csv file for use in other applications`,
      },
    ];
  }

  // ✅ **Start Intro.js**
  introJs()
    .setOptions({
      skipLabel: 'Dismiss',
      steps: steps,
      disableInteraction: true, // Prevents accidental interactions
      scrollToElement: false, // Disables automatic scrolling
      positionPrecedence: ["bottom", "top", "right", "left"], // Ensures best fit
    })
    .onexit(function () {
      _this.setData(_this.oldData);
      _this.activeTab = ['Your Result'];
      _this.inDemo = false;
    })
    .onbeforechange(function (targetElement) {
      if (targetElement.id === 'other_debt_payments_card') {
        _this.billSectionShow = true;
      }
    })
    .start();
}, 4500);
    },
    startOver() {
      this.current_step = 1;
    },
    onSeourceSelect: _.debounce(async function (i, input = true) {
      const value = await this.recalculateNetAsync(
        this.unmaskMoneyValue(this.net_amount[i].amount) * this.net_amount[i].freq,
        this.net_amount[i].grossOrNet
      );
      if (this.net_amount[i].grossOrNet === 'gross') {
        this.net_amount[i].gross = (this.unmaskMoneyValue(this.net_amount[i].amount) * this.net_amount[i].freq) / 12;
        this.net_amount[i].net = value;
      } else {
        this.net_amount[i].net = (this.unmaskMoneyValue(this.net_amount[i].amount) * this.net_amount[i].freq) / 12;
        this.net_amount[i].gross = value;
      }
    }, 400),
    checkLoggedIn() {
      return (
        (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data) || this.$cookies.get('userDetail')
      );
    },
    incomeChange(key, manual) {
      const inc = _.cloneDeep(this.net_amount);
      if (manual === '2') {
        inc[key] = {
          amount: '',
          freq: 12,
          manual: manual,
          occupation: null,
          level: null,
          grossOrNet: manual == '2' ? 'net' : 'gross',
          net: 0,
          gross: 0,
        };
      }

      inc[key] = {
        amount: '',
        freq: 12,
        manual: manual,
        occupation: null,
        level: null,
        grossOrNet: 'net',
        net: 0,
        gross: 0,
      };
      const ocp_selected = inc.filter((item) => item.manual === '1');
      if (ocp_selected.length == 0) {
        this.occupationAIText = [];
      }
      this.net_amount = inc;
    },
    async levelChange(key, level, occupation, isOccupationChange = false) {
      if (occupation && level) {
        const selectedOccupation = this.occupations.find((item) => item.id == occupation);
        let occ = null;

        if (level == 1) {
          occ = `${selectedOccupation.low.toFixed(0)}`;
        } else if (level == 2) {
          occ = `${selectedOccupation.median.toFixed(0)}`;
        } else if (level == 3) {
          occ = `${selectedOccupation.high.toFixed(0)}`;
        }
        const inc = _.cloneDeep(this.net_amount);

        const url = 'https://api.spendid.io/v1.0/calculators/net-income?gross=';
        const URI = `${url}${occ}&zip=${this.zip}`;
        const config = {
          headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
        };
        const net = await this.$http.get(URI, config);

        inc[key] = {
          amount: occ,
          freq: 1,
          manual: '1',
          occupation,
          level: level,
          grossOrNet: 'gross',
          gross: parseInt(occ / 12),
          net: net.data.net_annual_income / 12,
        };

        this.net_amount = inc;
      } else {
        const inc = _.cloneDeep(this.net_amount);
        inc[key] = {
          ...inc[key],
          amount: '0',
          freq: 1,
          manual: '1',
          grossOrNet: 'gross',
          gross: 0,
          net: 0,
        };
        this.net_amount = inc;
      }
      if (isOccupationChange) {
        if (occupation) {
          this.fillOccupationText(occupation);
        } else {
          this.occupationAIText = [];
        }
      }
    },
    async fillOccupationText(occupation) {
      const existingOccupation = this.net_amount
        .filter((item) => item.manual === '1' && item.occupation)
        .map((item) => item.occupation);
      existingOccupation.push(occupation);
      const formData = new FormData();
      formData.append('req', existingOccupation);
      this.occupationAILoad = true;
      this.occupationAIText = [];
      const result = await this.$http.post('https://admin.spendid.io/api/get-occupation-data', {
        req: existingOccupation,
      });
      this.occupationAILoad = false;
      this.occupationAIText = result.data.result;
    },
    predictGrowthChange() {
      this.predictGrowth = this.predictGrowth && parseFloat(this.predictGrowth).toFixed(1).toString();
      if (this.predictGrowth < 0) {
        this.predictGrowth = this.predictGrowth * (-1)
      }
      this.projectGrowthView(this.predictGrowth)
    },
    generateNumbers(age) {
      const min = age;
      const max = 65;
      const totalNumbers = 5;
      const gap = (max - min) / (totalNumbers - 1); // Calculate the gap between numbers

      const numbers = [];

      for (let i = 0; i < totalNumbers; i++) {
        const number = min + i * gap;
        if (number <= 65) {
          numbers.push(Math.ceil(number));
        } else {
          break; // Stop if the next number exceeds 65
        }
      }
      return numbers;
    },
    generateGrowthChart(values) {
      // Initialize AmCharts
      am4core.useTheme(am4themes_animated);

      // Create a chart instance
      const chart = am4core.create('chartdiv', am4charts.XYChart);

      // Add data
      chart.data = values; // Make sure "values" is an array of objects with "age" and "value" properties

      // Add legend
      chart.legend = new am4charts.Legend();

      // Add bottom label
      var label = chart.chartContainer.createChild(am4core.Label);
      label.text = 'Age';
      // label.marginTop = -50;
      label.align = 'center';
      label.fontWeight = 600;

      // Create category axis
      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'age';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 40;
      categoryAxis.renderer.labels.template.rotation = -60;
      categoryAxis.renderer.labels.template.verticalCenter = 'middle';
      categoryAxis.renderer.labels.template.horizontalCenter = 'right';

      // Create value axis
      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.numberFormatter.numberFormat = '$#,###';

      // Create line series
      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = 'value';
      series.dataFields.categoryX = 'age';
      series.name = 'You';
      series.tooltipText = '{categoryX}: [bold]{valueY}[/]';
      series.fill = am4core.color('#0E6DE5');
      series.stroke = am4core.color('#0E6DE5');
      // Create bullet (marker) for tooltips
      const bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.fill = am4core.color('#0E6DE5');
      bullet.circle.stroke = am4core.color('#0E6DE5');

      // Create second line series
      const series2 = chart.series.push(new am4charts.LineSeries());
      series2.dataFields.valueY = 'value2'; // Replace with the property for the second series values in your data
      series2.dataFields.categoryX = 'age';
      series2.name = 'Peers';
      series2.tooltipText = '{categoryX}: [bold]{valueY}[/]';
      series2.fill = am4core.color('#2BA195');
      series2.stroke = am4core.color('#2BA195');

      // Create bullet (marker) for tooltips for the second series
      const bullet2 = series2.bullets.push(new am4charts.CircleBullet());
      bullet2.fill = am4core.color('#2BA195'); // Change marker color if needed
      bullet2.circle.stroke = am4core.color('#2BA195');

      // Enable zoom and pan (optional)
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.behavior = 'zoomXY';
    },
    calculateInvestment(endYears, returnRate, compoundFrequency, monthlyContribution) {
      // Convert annual return rate to monthly rate
      const monthlyRate = returnRate / 100 / 12;
      const totalMonths = endYears * 12;

      let endBalance = 0;

      for (let month = 1; month <= totalMonths; month++) {
        // Calculate interest for the current month
        const interest = endBalance * monthlyRate;
        // Add the monthly contribution at the end of the month
        endBalance = endBalance + interest + monthlyContribution;
      }

      return endBalance.toFixed(0) < 0 ? 0 : endBalance.toFixed(0);
    },
    openProjectedGrowth() {
      let projectGrowth = localStorage.getItem('projectGrowth') || 6;
      if (projectGrowth) {
        projectGrowth = parseFloat(projectGrowth).toFixed(1);
        this.projectGrowthView(projectGrowth);
      }
    },
    projectGrowthView(percentageIncrease) {
      const monthly_cash_excess = parseInt(this.unmaskMoneyValue(this.investmentBalance));
      const saving = this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      const currentAge = parseInt(this.age);
      const diff = this.generateNumbers(currentAge);
      localStorage.setItem('projectGrowth', percentageIncrease);
      const values = diff.map((item) => {
        var gap = item - currentAge;
        return {
          age: `${item}yr`,
          value:
            gap > 0
              ? this.calculateInvestment(gap, percentageIncrease, 'monthly', monthly_cash_excess)
              : monthly_cash_excess < 0
                ? 0
                : monthly_cash_excess,
          value2:
            gap > 0
              ? this.calculateInvestment(gap, percentageIncrease, 'monthly', saving.peer_monthly)
              : saving.peer_monthly < 0
                ? 0
                : saving.peer_monthly,
        };
      });
      this.predictGrowth = percentageIncrease;
      setTimeout(() => {
        this.generateGrowthChart(values);
      }, 500);
    },
    async getOccupation() {
      const URI = 'https://api.spendid.io/v1.0/occupations';

      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
      };
      const occu = await this.$http.get(URI, config);
      this.occupations = occu.data.occupations;
    },
    defaultActiveTabAction(event) {
      this.defaultActiveTab = event;
    },
    async recalculateNetAsync(amount, grossOrNet) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel('Operation canceled due to new request.');
      }
      this.cancelToken = axios.CancelToken.source();
      const url =
        grossOrNet === 'gross'
          ? 'https://api.spendid.io/v1.0/calculators/net-income?gross='
          : 'https://api.spendid.io/v1.0/calculators/gross-income?net=';

      const URI = `${url}${amount}&zip=${this.zip}`;
      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      return (
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12)
      );
    },
    async recalculateNet(amount) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel('Operation canceled due to new request.');
      }
      this.cancelToken = axios.CancelToken.source();

      const url =
        this.grossOrNet === 'gross'
          ? 'https://api.spendid.io/v1.0/calculators/net-income?gross='
          : 'https://api.spendid.io/v1.0/calculators/gross-income?net=';

      const URI = `${url}${amount * 12}&zip=${this.zip}`;
      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      this.netAmount =
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12);

      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    // pageReload() {
    //   window.location.href = 'https://business.spendid.io/login';
    // },
    resetUserActivityTimeout() {
      if (this.$cookies.get('userDetail') && this.$cookies.get('userDetail').data.access_token) {
        clearTimeout(this.userActivityTimeout);
        this.userActivityTimeout = setTimeout(() => {
          this.inactiveUserAction();
        }, 900000);
      }
    },
    inactiveUserAction() {
      // this.$refs['logout-popup'].show();
      this.$cookies.remove('userDetail');
      this.$cookies.remove('storedData');
      this.$cookies.remove('assessmentId');
      this.$cookies.remove('dontshow');
      localStorage.removeItem('accessToken');
    },
    async fillAutoData(data) {
      if (data.data.data.demographics) {
        const demog = data.data.data.demographics;
        const budget = data.data.data.budget;
        this.age = demog.age;
        this.selectedZip = zip_codes.find((item) => item['Zip Code'] == demog.zip);
        this.zipCode = demog.zip;
        this.household_members = demog.household_members;
        this.is_homeowner = demog.is_homeowner === 1 || demog.is_homeowner === true || demog.is_homeowner === 'true';
        this.net_amount = JSON.parse(demog.grossOrNet);

        const ocp_selected = JSON.parse(demog.grossOrNet).filter((item) => item.manual === '1');
        if (demog.level.length > 20) {
          const debt = JSON.parse(demog.level);
          if (debt) {
            this.month_debs = debt.month_debs;
            this.otherDebtPayments = debt.otherDebtPayments;
            this.creditDebtPayment = debt.creditDebtPayment;
            this.studentLoan = debt.studentLoan;
            this.alimonyPayments = debt.alimonyPayments;
            this.homeEquityPayment = debt.homeEquityPayment;
            this.childSupportPayments = debt.childSupportPayments;
            this.estimatedTaxPayments = debt.estimatedTaxPayments;
          }
        }
        if (ocp_selected.length > 0 && ocp_selected[0].occupation) {
          this.fillOccupationText(ocp_selected[0].occupation);
        } else {
          this.occupationAIText = [];
        }
        this.stepEnable = false;
        this.$cookies.set('stepEnable', false);
        const rest = {};
        const rest_data = {};

        if (budget.other_debt_payments != null) {
          this.debt_input_value = `$${(budget.other_debt_payments / 12).toFixed(0)}`;
          rest_data['other_debt_payments'] = budget.other_debt_payments;
        }

        if (budget.mortgage_and_rent != null) {
          this.mortgage_and_rent_input_value = `$${(budget.mortgage_and_rent / 12).toFixed(0)}`;
          rest_data['mortgage_and_rent'] = budget.mortgage_and_rent;
        }

        if (budget.vehicle_purchase_and_lease != null) {
          this.vehicle_purchase_and_lease_input_value = `$${(budget.vehicle_purchase_and_lease / 12).toFixed(0)}`;
          rest_data['vehicle_purchase_and_lease'] = budget.vehicle_purchase_and_lease;
        }

        if (budget.health_insurance != null) {
          this.health_insurance_input_value = `$${(budget.health_insurance / 12).toFixed(0)}`;
          rest_data['health_insurance'] = budget.health_insurance;
        }

        if (data.data.data.isRequestBudget) {
          const otherData = Object.keys(transformer_38).filter((item, k) => k > 4);
          await otherData.map((item) => {
            if (data.data.data.isRequestBudget[item]) {
              rest_data[item] = parseInt(data.data.data.isRequestBudget[item]);
              rest[item] = {
                value: (data.data.data.isRequestBudget[item] / 12).toFixed(0),
                freq: 12,
              };
            }
            return true;
          });
          this.changedValuesText = rest;
          this.changedValues = rest_data;

          if (data.data.data.eliminatedCategories && data.data.data.eliminatedCategories.length > 0) {
            const resultObject = data.data.data.eliminatedCategories.reduce((acc, key) => {
              acc[key] = 0;
              return acc;
            }, {});
            this.eliminated = resultObject;
          } else {
            this.eliminated = {};
          }

          //   this.updateCharts();
        }

        this.activeTab = ['Your Result'];
        if (this.unmaskMoneyValue(demog.balance)) {
          var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          });
          this.investmentBalanceFixed = true;
          this.investmentBalance = formatter.format(parseInt(this.unmaskMoneyValue(demog.balance)));
        } else {
          this.investmentBalance = '$0';
        }
      } else {
        this.stepEnable = false;
        this.$cookies.set('stepEnable', false);
        this.activeTab = ['Your Profile'];
      }

      // setTimeout(() => {
      //   this.updateCharts();
      // }, 2000);
    },
    goto(activeTabTitle) {
      this.activeTab = [activeTabTitle];
      window.scrollTo(0, 0);
    },
    async saveReport() {
      let headers = {
        Authorization: 'Bearer ' + this.$cookies.get('userDetail').data.access_token,
      };
      this.$http
        .post(
          `${new_api}/report-save`,
          {
            name: 'new Report',
          },
          { headers }
        )
        .then((res) => {
          this.$cookies.set('assessmentId', res.data.reportId);

          const debt = {
            month_debs: this.month_debs,
            otherDebtPayments: this.otherDebtPayments,
            creditDebtPayment: this.creditDebtPayment,
            studentLoan: this.studentLoan,
            alimonyPayments: this.alimonyPayments,
            homeEquityPayment: this.homeEquityPayment,
            childSupportPayments: this.childSupportPayments,
            estimatedTaxPayments: this.estimatedTaxPayments,
          };

          const req = {
            userInfo: {
              email: this.user_email,
              name: this.user_name,
              usecase: this.defaultUseCase,
              edu: this.defaultEducation,
              key: this.key,
              reportId: res.data.reportId,
            },
            methods: {
              incomeMethod: this.income_method_val.toString(),
              occupationSelctor: this.occupations_val,
              level: JSON.stringify(debt),
              balance: this.investmentBalance,
              grossOrNet: JSON.stringify(this.net_amount),
            },
            apiReq: this.apiReq,
            callDemographicsAPIRes: this.callDemographicsAPIRes,
            callBudgetAPIRes: this.callBudgetAPIRes,
            callScoringAPIRes: this.callScoringAPIRes,
            callLendingScoreAPIRes: this.callLendingScoreAPIRes,
            eliminated: this.eliminated,
          };

          const signature = crypto
            .createHmac('sha256', 'caa738fb-1ee7-4736-92c8-a3fdece2d554')
            .update('spendidio' + this.user_email)
            .digest('hex');

          window.Upfocus = {
            product: 'spendidio',
            email: this.user_email,
            signature,
          };

          const headers = {
            Authorization: 'Bearer ' + this.$cookies.get('userDetail').data.access_token,
          };
          this.$http.post('https://panel.spendid.io/spendid_analytic/public/api/store-user-info-with-report', req, {
            headers,
          });
          this.saveReportPopUp = true;
          setTimeout(() => {
            this.saveReportPopUp = false;
          }, 400);
          this.$toasted.success('Report Saved').goAway(400);
          window.localStorage.removeItem('saveReport');
          this.dataSent = req;
        });
    },
    handleFocusOut() {
      try {
        this.$refs.coreexp[0].hideMenus();
        this.$refs.coreexp[1].hideMenus();
        this.$refs.coreexp[2].hideMenus();
        this.$refs.coreexp[3].hideMenus();
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },
    submitStepForm(data) {
      this.stepEnable = false;
      this.$cookies.set('stepEnable', false);
      this.age = data.age;
      this.household_members = parseInt(data.numberOfPeople);
      this.selectedZip = zip_codes.find((item) => item['Zip Code'] == data.zip);
      this.zipCode = data.zip;
      this.is_homeowner = data.rentOrOwn === 'own';
      this.net_amount = data.incomes;
      const ocp_selected = data.incomes.filter((item) => item.manual === '1');
      if (ocp_selected.length > 0 && ocp_selected[0].occupation) {
        if (data.occupationAIText.length == 0) {
          this.fillOccupationText(ocp_selected[0].occupation);
        } else {
          this.occupationAIText = data.occupationAIText;
        }
      } else {
        this.occupationAIText = [];
      }
      this.user_email = data.finalEmail;
      this.user_name = data.finalEmail;
      this.grossOrNet = data.grossOrNet;
      (this.annual_gross_salary_level_val = data.annual_gross_salary_level_val),
        (this.occupations_val = data.occupations_val),
        (this.income_method_val = data.income_method === '2' ? false : true);
      this.mortgage_and_rent_input_value = `$${data.monthlyRent}` || '0';
      this.mortgage_and_rent_input_value_freq = 12;
      this.vehicle_purchase_and_lease_input_value = `$${data.totalMonthly}` || '0';
      this.vehicle_purchase_and_lease_input_value_freq = 12;

      this.health_insurance_input_value_freq = 12;

      const rest_data = {};
      const rest = {};

      const debt = [
        data.otherDebtPayments,
        data.creditDebtPayment,
        data.studentLoan,
        data.alimonyPayments,
        data.homeEquityPayment,
        data.childSupportPayments,
        data.estimatedTaxPayments,
      ]
        .filter(Number)
        .reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0);

      this.otherDebtPayments = data.otherDebtPayments;
      this.creditDebtPayment = data.creditDebtPayment;
      this.studentLoan = data.studentLoan;
      this.alimonyPayments = data.alimonyPayments;
      this.homeEquityPayment = data.homeEquityPayment;
      this.childSupportPayments = data.childSupportPayments;
      this.estimatedTaxPayments = data.estimatedTaxPayments;
      this.month_debs = data.month_debs;

      if (data.monthlyRent) {
        rest['mortgage_and_rent'] = data.monthlyRent ? parseInt((data.monthlyRent ? data.monthlyRent : 0) * 12) : 0;
      }

      if (data.totalMonthly) {
        rest['vehicle_purchase_and_lease'] = data.totalMonthly
          ? parseInt((data.totalMonthly ? data.totalMonthly : 0) * 12)
          : 0;
      }

      if (data.healthPremiumAmount || data.age >= 26) {
        this.health_insurance_input_value = `$${data.healthPremiumAmount}` || '$0';

        rest['health_insurance'] = data.healthPremiumAmount
          ? parseInt((data.healthPremiumAmount ? data.healthPremiumAmount : 0) * 12)
          : 0;
        rest['other_debt_payments'] = debt ? parseInt((debt ? debt : 0) * 12) : 0;
      } else {
        this.health_insurance_input_value = '0';

        rest['health_insurance'] = data.healthPremiumAmount
          ? parseInt((data.healthPremiumAmount ? data.healthPremiumAmount : 0) * 12)
          : 0;
        rest['other_debt_payments'] = debt ? parseInt((debt ? debt : 0) * 12) : 0;
      }

      this.changedValuesText = rest_data;
      this.changedValues = rest;

      this.debt_input_value = `$${debt}` || '0';
      this.debt_input_value_freq = 12;
      this.visibleOtherExpCat = false;
      this.visibleCoreExpCat = true;
      if (window.innerWidth <= 800) {
        this.visibleProfileHousehold = false;
      } else {
        this.visibleProfileHousehold = true;
      }
      // this.$bvModal.show('instructionModal');
      setTimeout(() => {
        this.goto('Your Result');
      }, 400);
      setTimeout(() => {
        this.newIntroStart();
      }, 400);
    },
    addIncome() {
      this.net_amount.push({
        amount: '',
        freq: 12,
        manual: '2',
        occupation: null,
        level: null,
        grossOrNet: 'net',
        net: 0,
        gross: 0,
      });
    },
    deleteIncome(counter) {
      this.net_amount.splice(counter, 1);
      const ocp_selected = this.net_amount.filter((item) => item.manual === '1');
      if (ocp_selected.length > 0 && ocp_selected[0].occupation) {
        this.fillOccupationText(ocp_selected[0].occupation);
      } else {
        this.occupationAIText = [];
      }
    },
    verifyEmail() { },
    validateCheck() {
      if (!this.user_name) {
        // this.$toasted.error('Name is required.').goAway(1500);
        /* eslint-disable */
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user_email)) {
        // this.$toasted.error('Email is required.').goAway(1500);
      } else if (!this.age || this.age < 18) {
        // this.$toasted.error('Age must be 18+').goAway(1500);
      }
    },
    changeEdu(arg) {
      this.defaultEducation = arg;
    },
    changeUseCase(arg) {
      this.useCase = arg;
      this.defaultUseCase = arg;
    },
    async loadUser() {
      this.loginLoading = true;
    },
    onSubmit(e) {
      e.preventDefault();
    },
    setData(data) {
      if (data.net_amount) {
        this.net_amount = data.net_amount;
        setTimeout(() => {
          const ocp_selected = data.net_amount.filter((item) => item.manual === '1');
          if (ocp_selected.length > 0 && ocp_selected[0].occupation) {
            this.fillOccupationText(ocp_selected[0].occupation);
          } else {
            this.occupationAIText = [];
          }
        }, 400);
      }

      if (data.monthly_take_home)
        if (data.monthly_take_home_feq)
          // this.monthly_take_home_input_value = `${data.monthly_take_home}`;

          this.monthly_take_home_input_value_freq = `${data.monthly_take_home_feq}`;

      if (data.age) this.age = parseInt(data.age);

      if (data.household_members) this.household_members = parseInt(data.household_members);

      if (data.zip) {
        this.selectedZip = zip_codes.find((item) => item['Zip Code'] == data.zip);
        this.zipCode = data.zip;
      }

      if (data.is_homeowner) this.is_homeowner = data.is_homeowner;

      if (data.saving.value != null) this.savings_input_value = `$${data.saving.value}`;

      if (data.saving.freq) this.savings_input_value_freq = data.saving.freq;

      if (data.other_debt_payments.value != null) this.debt_input_value = `$${data.other_debt_payments.value}`;

      if (data.other_debt_payments.freq) this.debt_input_value_freq = data.other_debt_payments.freq;

      if (data.mortgage_and_rent.value != null) this.mortgage_and_rent_input_value = `$${data.mortgage_and_rent.value}`;

      if (data.mortgage_and_rent.freq) this.mortgage_and_rent_input_value_freq = data.mortgage_and_rent.freq;

      if (data.vehicle_purchase_and_lease.value != null)
        this.vehicle_purchase_and_lease_input_value = `$${data.vehicle_purchase_and_lease.value}`;

      if (data.vehicle_purchase_and_lease.freq)
        this.vehicle_purchase_and_lease_input_value_freq = data.vehicle_purchase_and_lease.freq;

      if (data.health_insurance.value != null) this.health_insurance_input_value = `$${data.health_insurance.value}`;

      if (data.health_insurance.freq) this.health_insurance_input_value_freq = data.health_insurance.freq;

      if (data.rest) this.changedValuesText = data.rest;

      if (data.rest2) this.changedValues = data.rest2;

      if (data.user_name) this.user_name = data.user_name;

      if (data.user_email) this.user_email = data.user_email;

      if (data.eliminated && typeof data.eliminated === 'object' && Object.keys(data.eliminated).length > 0) {
        this.eliminated = data.eliminated;
      } else {
        this.eliminated = {};
      }
      if (data.billSectionShow) {
        this.billSectionShow = data.billSectionShow;
      }
      if (data.debtData) {
        this.month_debs = data.debtData.month_debs;
        this.otherDebtPayments = data.debtData.otherDebtPayments;
        this.creditDebtPayment = data.debtData.creditDebtPayment;
        this.studentLoan = data.debtData.studentLoan;
        this.alimonyPayments = data.debtData.alimonyPayments;
        this.homeEquityPayment = data.debtData.homeEquityPayment;
        this.childSupportPayments = data.debtData.childSupportPayments;
        this.estimatedTaxPayments = data.debtData.estimatedTaxPayments;
        if (data.debtData.month_debs == 'yes') {
          this.submitDebt();
        } else if (data.debtData.month_debs == 'no') {
          this.submitDebtNo();
        }
      }
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
      const short_code = arg2.replace('_input_value', '');
      const short_code_detail = transformer_38[short_code];
      const short_code_freq = this[`${arg2}_freq`];
      this.changeValue(short_code_detail, arg * short_code_freq, arg, short_code_freq);
    },
    login() {
      this.$router.push('/login');
      // this.$auth.loginWithRedirect();
    },
    getPieChartData(objects) {
      const needs = _.sumBy(objects, function (o) {
        return o.type === 'needs' ? o.monthly : 0;
      });
      const wants = _.sumBy(objects, function (o) {
        return o.type === 'wants' ? o.monthly : 0;
      });
      const saving = _.sumBy(objects, function (o) {
        return o.type === 'saving' ? o.monthly : 0;
      });

      const needsPercent = (needs / (needs + wants + saving)) * 100;
      const wantsPercent = (wants / (needs + wants + saving)) * 100;
      const savingPercent = (saving / (needs + wants + saving)) * 100;

      return [
        {
          category: 'Needs',
          monthly: needsPercent.toFixed(1),
        },
        {
          category: 'Wants',
          monthly: wantsPercent.toFixed(1),
        },
        {
          category: 'Financial Goals',
          monthly: savingPercent.toFixed(1),
        },
      ];
    },
    changeMode(e) {
      this.dark = e;
      if (document.body.classList.contains('darkmode')) {
        var element = document.querySelector('body');
        element.classList.remove('darkmode');
      } else {
        var element = document.querySelector('body');
        element.classList.add('darkmode');
      }
      try {
        localStorage.setItem('mode', e);
      } catch (e) {
        // eslint-disable-next-line no-console
      }
      this.updateChartsCached();
    },
    changePage(arg) {
      this.page = arg;
    },
    checkForValidate() {
      /* eslint-disable */
      if (
        this.zipCode &&
        this.zipCode.length === 5 &&
        this.age > 17
        // &&
        // this.household_members > 0
      ) {
        return true;
      }
      return false;
    },
    returnDefaultTextOnly() {
      const score = this.scores && this.scores.breakeven && parseFloat(this.scores.breakeven);
      var data = {};
      if (score === 0 || score < 0) {
        data['mainText'] = `Tell SPENDiD a little about your Household Profile, Income and Major Fixed Expenses`;
        data['descriptiveText'] = '';
      } else if (score <= 59 && score > 0) {
        // data['mainText']='F'
        data['mainText'] = '';
        data['descriptiveText'] =
          `Looks like it may be difficult to make ends meet. First, ensure all your Profile and Major Fixed Expense inputs are correct. Then look at the Potential Focus Areas below to see where you can make changes for the biggest impact.`;
      } else if (score > 59 && score < 70) {
        // data['mainText']='D'
        data['mainText'] = '';
        data['descriptiveText'] =
          `Your budget situation probably causes a high stress level as you try to make ends meet. Looking at your Potential Focus Areas below, what major expenses can you potentially reduce to raise your SPENDiD Score and lower your financial stress?`;
      } else if (score >= 70 && score < 80) {
        // data['mainText']='C'
        data['mainText'] = '';
        data['descriptiveText'] =
          `You may find it hard to make ends meet during most months, but you're not far away from being able to start a real savings strategy. Can you reduce spending anywhere in the list of Potential Focus Areas below, or "side-gig" for more income?`;
      } else if (score >= 80 && score < 85) {
        data['mainText'] = 'B';
        data['descriptiveText'] =
          `Your budget situation looks to be pretty good! Hopefully you’re saving at least ${this.lending_score_cash_excess_formatted} or more each month. Can you reduce expenses in categories where your spending is higher than your peers so you can save even more?`;
      } else if (score >= 85 && score < 90) {
        data['mainText'] = 'B +';
        data['descriptiveText'] =
          `You appear to be doing really well vs your peers and hopefully are setting aside at least ${this.lending_score_cash_excess_formatted} monthly from your take-home income to a separate savings account. TIP:  If you haven’t already, consider automating a savings transfer each pay period before you can spend it!`;
      } else if (score >= 90 && score <= 99) {
        data['mainText'] = 'A';
        data['descriptiveText'] =
          `Congratulations on a strong cash-flow situation! You definitely have the ability to set aside at least ${this.lending_score_cash_excess_formatted} each month to a separate savings or investment account. Keep your specific goals in mind as to what you’re saving for, and you’ll make it happen. Make 100 or higher your SPENDiD Score goal!`;
      } else if (score > 99) {
        data['mainText'] = 'A +';

        data['descriptiveText'] =
          `It looks like you're doing all the right things budget-wise. Do you have an active strategy for growing your savings, and investing for the future? Be sure to sweep at least ${this.lending_score_cash_excess_formatted} into investments appropriate for your age and risk tolerance. Do this, and your financial future looks bright!`;
      }
      return data;
    },
    async restoreEliminate(arg) {
      this.filtered_barchart = this.filtered_barchart.map((item) => {
        if (item.category === arg) {
          return { ...item, isActive: true };
        }
        return item;
      });
      const key = Object.keys(transformer_38).find((item) => transformer_38[item] === arg);
      delete this.eliminated[key];
      const that = this;
      await this.updateCharts().then(function () {
        setTimeout(() => {
          that.changeFilter(that.sortDefault);
        }, 400);
      });
    },
    async runElimination() {
      this.filtered_barchart = this.filtered_barchart.map((item) => {
        if (item.category === this.defaultSelectedEliminationName) {
          return { ...item, isActive: false };
        }
        return item;
      });
      const key = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.defaultSelectedEliminationName
      );
      delete this.changedValues[key];
      this.eliminated[key] = 0;
      this.$bvModal.hide('eliminated');
      await this.updateCharts();
    },
    openModelEliminate(arg) {
      this.defaultSelectedEliminationName = arg;
      // this.$bvModal.show('eliminated')
      this.runElimination();
    },
    resetDefault(bBypassDiv, arg2 = 'all') {
      if (bBypassDiv) {
        this.byPass = bBypassDiv;
        this.stepEnable = bBypassDiv;
        this.$cookies.set('stepEnable', bBypassDiv);
        // return true;
      }
      if (arg2 == 'all') {

        this.net_amount = [
          {
            amount: '',
            freq: 12,
            manual: '2',
            occupation: null,
            level: null,
            grossOrNet: 'net',
            net: 0,
            gross: 0,
          },
        ];
      }
      // this.StartOverModal= false;
      this.$bvModal.hide('startover');
      this.visibleResultsSummary = false;
      this.visibleYourHousehold = false;
      this.visibleCoreExp = false;
      this.visibleCustCoreExp = false;
      this.visibleVhCustCoreExp = false;
      this.visibleDbtCustCoreExp = false;
      this.visibleSvAmtCoreExp = false;
      this.visiblePersComp = false;
      this.visibleCoreExpCat = false;
      this.visibleProfileHousehold = true;
      this.visibleOtherExpCat = false;
      this.visibleCommonBillsCat = true;
      this.visibleMonthlyBillsCat = true;
      this.visibleDisabledCat = false;
      this.visibleResultDetails = false;
      this.visibleYourBudget = false;
      this.visibleYourPeers = false;
      this.visibleCashHealthAnalysis = true;
      this.visibleFAQ = false;
      this.visibleFaqOne = false;
      this.visibleFaqTwo = false;
      this.visibleFaqThree = false;
      this.visibleFaqFour = false;
      this.visibleFaqFive = false;
      this.visibleFaqSix = false;
      this.visibleFaqSeven = false;
      this.visibleFaqEight = false;
      this.visibleFaqNine = false;
      this.visibleFaqTen = false;
      this.visibleFaqEleven = false;
      this.visibleFaqTwelve = false;
      this.visibleFaqThirteen = false;
      this.visibleFaqFourteen = false;
      this.visibleFaqFifteen = false;
      this.visibleModalPieChart = false;
      // this.monthly_take_home_input_value= "0";
      this.monthly_take_home_input_value_freq = 12;

      if (arg2 == 'all') {
        this.age = '';
        this.household_members = 1;
        this.zip = '';
        (this.zipCode = null), (this.selectedZip = null);
        this.is_homeowner = null;
      }
      this.investmentBalanceFixed = false;
      this.investmentBalance = '$0';
      this.filter_cateory = '';
      this.selected_category = Math.random().toString();
      this.sortBy = 'category';
      this.sortDefault = false;
      this.sortType = '';
      this.isHidden = true;
      (this.zipcodeId = ''), (this.checked = true);
      this.chart = null;
      this.chart_range = 'month';
      this.is_typing = false;
      this.api_updates_pending = false;
      this.active_persona_index = 0;
      this.budget = null;
      this.demographics_response = null;
      this.scores = null;
      this.lending_score = null;
      this.peers_input_value = null;
      this.filtered_barchart = null;
      this.savings_input_value = null;
      this.savings_input_value_freq = 12;
      this.mortgage_and_rent_input_value = null;
      this.mortgage_and_rent_input_value_freq = 12;
      this.vehicle_purchase_and_lease_input_value = null;
      this.vehicle_purchase_and_lease_input_value_freq = 12;
      this.health_insurance_input_value = null;
      this.health_insurance_input_value_freq = 12;
      this.debt_input_value = null;
      this.debt_input_value_freq = 12;
      this.peer_income = '--';
      this.budgetFilter = null;
      this.peerFilter = null;
      this.differenceFilter = null;
      this.changedValues = {};
      this.changedValuesText = {};
      this.eliminated = {};
      this.billSectionShow = false;
      this.byPass = bBypassDiv;
      this.netAmount = 0;
      this.month_debs = null;
      this.creditDebtPayment = null;
      this.studentLoan = null;
      this.alimonyPayments = null;
      this.homeEquityPayment = null;
      this.childSupportPayments = null;
      this.estimatedTaxPayments = null;
      this.otherDebtPayments = null;
      this.occupationAIText = [];
      // window.scrollTo(0,0);
      try {
        this.$cookies.remove('storedData');
        localStorage.removeItem('projectGrowth');
      } catch (e) {
        // eslint-disable-next-line no-console
      }
      this.useCase = null;
      this.defaultUseCase = null;
      this.defaultEducation = null;
      this.user_name = '';
      this.user_email = '';
      this.otp = '';
      this.stepEnable = bBypassDiv;
      this.$cookies.set('stepEnable', bBypassDiv);
      window.scrollTo(0, 0);
      this.goto('Your Profile');
    },
    resetlogout() {
      this.stepEnable = true;
      this.$cookies.set('stepEnable', true);
    },
    async changeValue(type, value, amount, freq) {
      const key = Object.keys(transformer_38).filter((item) => transformer_38[item] === type);

      key.forEach((item) => {
        if (amount) {
          this.changedValues[item] = value ? value / key.length : value;
          this.changedValuesText[key] = {
            value: amount,
            freq,
          };
        } else if (!value) {
          delete this.changedValues[item];
          delete this.changedValuesText[key];
        }

        switch (item) {
          case 'other_debt_payments':
            this.debt_input_value = amount ? `${amount.toString()}` : null;
            this.debt_input_value_freq = freq;
            break;
          case 'mortgage_and_rent':
            this.mortgage_and_rent_input_value = amount ? `${amount.toString()}` : null;
            // this.mortgage_and_rent_value = this.mortgage_and_rent_input_value ? parseFloat(this.unmaskMoneyValue(this.mortgage_and_rent_input_value)) : null;
            this.mortgage_and_rent_input_value_freq = freq;
            break;
          case 'vehicle_purchase_and_lease':
            this.vehicle_purchase_and_lease_input_value = amount ? `${amount.toString()}` : null;
            this.vehicle_purchase_and_lease_input_value_freq = freq;
            break;
          case 'health_insurance':
            this.health_insurance_input_value = amount ? `${amount.toString()}` : null;
            this.health_insurance_input_value_freq = freq;
            break;
          case 'savings':
            this.savings_input_value = amount ? `${amount.toString()}` : null;
            this.savings_input_value_freq = freq;
            break;
          default:
            break;
        }
      });
      await this.updateCharts();
    },
    selectedSavingFreq() {
      return this.frequencyOptions.find((item) => item.value === this.savings_input_value_freq).text;
    },
    changeFilter(asc) {
      this.sortDefault = asc;
      const mainData = this.filtered_barchart;
      const firstFour = mainData && mainData.slice(0, 5);
      const restData = mainData && mainData.filter((item, i) => i > 4);
      if (this.sortBy === 'category') {
        restData.sort(function (a, b) {
          if (a.category < b.category) {
            return asc ? -1 : 1;
          }
          if (a.category > b.category) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === 'user_monthly') {
        restData.sort(function (a, b) {
          if (a.user_monthly < b.user_monthly) {
            return asc ? -1 : 1;
          }
          if (a.user_monthly > b.user_monthly) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === 'peer_monthly') {
        restData.sort(function (a, b) {
          if (a.peer_monthly < b.peer_monthly) {
            return asc ? -1 : 1;
          }
          if (a.peer_monthly > b.peer_monthly) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === 'difference') {
        restData.sort(function (a, b) {
          if (a.user_monthly - a.peer_monthly < b.user_monthly - b.peer_monthly) {
            return asc ? -1 : 1;
          }
          if (a.user_monthly - a.peer_monthly > b.user_monthly - b.peer_monthly) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      }

      this.filtered_barchart = [...firstFour, ...restData];
    },
    focusOut() {
      // if(parseInt(this.age)<18){
      //   this.age=18
      // }
    },
    score_to_grade(score) {
      let grade = 'F';

      if (score >= 96) {
        grade = 'A+';
      } else if (score >= 90 && score < 96) {
        grade = 'A-';
      } else if (score >= 86 && score < 90) {
        grade = 'B+';
      } else if (score >= 80 && score < 86) {
        grade = 'B';
      } else if (score >= 70 && score < 80) {
        grade = 'C';
      } else if (score >= 60 && score < 70) {
        grade = 'D';
      }
      return grade;
    },
    grade_to_css_class(grade) {
      return {
        'is-grade-a-plus': grade == 'A+',
        'is-grade-a': grade == 'A',
        'is-grade-a-minus': grade == 'A-',
        'is-grade-b-plus': grade == 'B+',
        'is-grade-b': grade == 'B',
        'is-grade-b-minus': grade == 'B-',
        'is-grade-c': grade == 'C',
        'is-grade-d': grade == 'D',
        'is-grade-f': grade == 'F',
      };
    },
    unmaskMoneyValue(val) {
      if (typeof val === 'string' && val.includes('$')) {
        return val.replace('$', '').replace(',', '');
      } else {
        return val;
      }
    },
    createSpeedChart(breakEven) {
      // Themes begin
      am4core.useTheme(am4themes_animated);
      // Themes end

      // create chart
      let chart = am4core.create('speedometer', am4charts.GaugeChart);
      chart.innerRadius = am4core.percent(70);

      /*** Normal axis*/
      let axis = chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = 0;
      axis.max = 100;
      axis.strictMinMax = true;
      axis.renderer.grid.template.stroke = new am4core.InterfaceColorSet().getFor('background');
      axis.renderer.grid.template.strokeOpacity = 0.3;
      axis.renderer.minGridDistance = 500;
      axis.renderer.labels.template.fontSize = '0.8em';
      axis.renderer.labels.template.fill = am4core.color(this.dark ? '#fff' : '#fff');

      axis.renderer.labels.template.adapter.add('text', function (text) {
        return text;
      });

      /*** Axis for ranges*/
      let colorSet = new am4core.ColorSet();

      let axis2 = chart.xAxes.push(new am4charts.ValueAxis());
      axis2.min = 0;
      axis2.max = 100;
      axis2.strictMinMax = true;
      axis2.renderer.labels.template.disabled = true;
      axis2.renderer.ticks.template.disabled = true;
      axis2.renderer.grid.template.disabled = true;
      let range3 = axis2.axisRanges.create();
      range3.value = 0;
      range3.endValue = 50;
      range3.axisFill.fillOpacity = 1;
      range3.axisFill.fill = colorSet.getIndex(0);
      var gradient1 = new am4core.LinearGradient();
      gradient1.addColor(am4core.color('#ff0000'));
      gradient1.addColor(am4core.color('#5868eb'));
      range3.axisFill.fill = gradient1;
      let range1 = axis2.axisRanges.create();
      range1.value = 50;
      range1.endValue = 100;
      range1.axisFill.fillOpacity = 1;
      range1.axisFill.fill = colorSet.getIndex(2);
      var gradient = new am4core.LinearGradient();
      gradient.addColor(am4core.color('#5868eb'));
      gradient.addColor(am4core.color('#1aa59b'));
      gradient.rotation = 0;

      range1.axisFill.fill = gradient;
      /*** Label*/
      let label = chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = 32;
      label.fontWeight = 600;
      label.x = am4core.percent(50);
      label.y = am4core.percent(100);
      label.horizontalCenter = 'middle';
      label.verticalBottom = 'bottom';
      label.text = '';
      label.fill = am4core.color(this.dark ? '#fff' : '#000');
      /*** Hand*/
      let hand = chart.hands.push(new am4charts.ClockHand());
      hand.axis = axis2;

      hand.value = this.roundSpeedValue(parseFloat(breakEven));
      hand.fill = am4core.color('#a7ff83');
      hand.stroke = am4core.color('#a7ff83');
      hand.events.on('propertychanged', function () {
        axis2.invalidate();
      });
      return chart;
    },
    roundSpeedValue(val) {
      if (val > 100) {
        return 100;
      } else if (val < 0) {
        return -0;
      } else {
        return val;
      }
    },
    createPieChart(data, ref, type = '$') {
      var _this = this;
      let chart = am4core.create(this.$refs[ref], am4charts.PieChart);
      let options = chart.exporting.getFormatOptions('png');
      options.minWidth = 1000;
      options.minHeight = 1000;
      options.maxWidth = 2000;
      options.maxHeight = 2000;
      chart.exporting.setFormatOptions('png', options);
      let mainData = data;
      if (type !== '$') {
        /* eslint-disable */
        mainData = data.map((item) => ({
          ...item,
          monthly: item.monthly >= 0 ? item.monthly : 0,
          dol: Math.trunc((_this.netAmountInput.replace(/[^\d\.\-]/g, '') * item.monthly) / 100),
        }));
      }
      chart.data = mainData;
      chart.padding(15, 10, 15, 10);
      chart.responsive.enabled = true;
      chart.maintainAspectRatio = true;
      var series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = 'monthly';
      series.dataFields.category = 'category';

      var slice = series.slices.template;
      slice.states.getKey('hover').properties.scale = 1;
      slice.states.getKey('active').properties.shiftRadius = 0;

      if (type != '$') {
        series.dataFields.dol = 'dol';
        series.slices.template.tooltipText =
          type == '$'
            ? '{category}: ${value}'
            : `{category}: {value}%
        $ {dol}`;
      } else {
        series.slices.template.tooltipText = type == '$' ? '{category}: ${value}' : '{category}: {value}%';
      }
      series.slices.template.cornerRadius = 10;
      series.legendSettings.labelText = '{category}';
      series.legendSettings.valueText = type == '$' ? '${value}' : '{value}%';

      chart.radius = am4core.percent(100);
      chart.innerRadius = am4core.percent(85);
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;

      series.colors.list = [
        am4core.color('#17CAB8'),
        am4core.color('#5E5CE6'),
        am4core.color('#F54F5F'),
        am4core.color('#FF8E29'),
        am4core.color('#1aa59b'),
        am4core.color('#8c2b86'),
        am4core.color('#73c03c'),
        am4core.color('#ffb31f'),
        am4core.color('#1aa59b'),
      ];

      chart.numberFormatter.numberFormat = '#,###';
      let label = series.createChild(am4core.Label);
      label.text = type == '$' ? '${values.value.sum}' : '';
      // label.text = type=='$'? _this.monthly_take_home_input_value : '100%';
      label.horizontalCenter = 'middle';
      label.align = 'center';
      label.verticalCenter = 'middle';
      label.fontSize = 28;
      label.fontWeight = 'bold';
      label.fill = am4core.color(this.dark ? '#fff' : '#000');
      label.marginTop = chart.chartContainer.pixelHeight / 2;
      label.marginLeft = chart.chartContainer.pixelWidth / 2;
      chart.responsive.enabled = true;
      series.slices.template.events.on('hit', function (ev) {
        if (type == '$') {
          const topCat = [
            'mortgage_and_rent',
            'vehicle_purchase_and_lease',
            'other_debt_payments',
            'savings',
            'health_insurance',
          ];
          _this.handleFocusOut();
          if (!topCat.includes(ev.target._dataItem._dataContext.category_type)) {
            _this.billSectionShow = true;
          }
          var elements = document.querySelectorAll('.add-fudget-form');

          // Remove the specific class from all matching elements
          elements.forEach(function (element) {
            element.classList.add('d-none');
          });
          if (topCat.includes(ev.target._dataItem._dataContext.category_type)) {
            setTimeout(() => {
              _this.activeTab = ['Your Major Expenses'];
            }, 400);
            _this.visibleCoreExp = true;
            _this.visibleCoreExpCat = true;
          } else if (common_monthly_short.includes(ev.target._dataItem._dataContext.category_type)) {
            setTimeout(() => {
              _this.activeTab = ['Common Monthly Bills'];
            }, 400);
            _this.visibleOtherExpCat = true;
          } else {
            setTimeout(() => {
              _this.activeTab = ['Other Discretionary Expenses'];
            }, 400);
            _this.visiblePersComp = true;
          }
          setTimeout(() => {
            scrollIntoView(document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card`), {
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
            setTimeout(() => {
              var element = document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card_click`);
              element.classList.remove('d-none');
            }, 200);
          }, 400);
        }
      });
      return chart;
    },
    createBarChart(comparison) {
      var _this = this;
      var chart = am4core.create('barchart', am4charts.XYChart);
      chart.paddingRight = 40;
      chart.paddingLeft = 0;
      chart.paddingBottom = 40;
      chart.colors.list = [am4core.color('#1aa59b')];
      let options = chart.exporting.getFormatOptions('png');
      options.minWidth = 1000;
      options.minHeight = 1000;
      options.maxWidth = 2000;
      options.maxHeight = 2000;
      chart.exporting.setFormatOptions('png', options);

      const gapData = comparison.map((item) => {
        return { ...item, gap: item.user_monthly - item.peer_monthly };
      });
      // sort by biggest difference first
      var dataArray = Object.keys(_this.changedValues).map(function (k) {
        if (_this.changedValues[k]) {
          return k;
        }
      });

      const mainData = gapData
        .filter((item) => item.category !== 'Amount to Savings Each Period')
        .sort((a, b) => (a.gap > b.gap ? -1 : b.gap > a.gap ? 1 : 0))
        .filter((item) => item.gap > 0 && dataArray.includes(item.category_type))
        .splice(0, 5);

      this.hideBarChart = mainData.length === 0;
      chart.data = mainData;
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'category';
      categoryAxis.numberFormatter.numberFormat = '$#,###';
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.cellStartLocation = 0.9;
      categoryAxis.renderer.cellEndLocation = 0.7;
      categoryAxis.renderer.labels.template.rotation = 0;
      categoryAxis.renderer.labels.template.fill = am4core.color(_this.dark ? '#fff' : '#000');
      categoryAxis.renderer.labels.template.verticalTop = 'top';
      categoryAxis.renderer.labels.template.wrap = false;
      categoryAxis.renderer.labels.template.truncate = false;
      categoryAxis.renderer.inside = true;
      categoryAxis.renderer.labels.template.valign = 'top';
      categoryAxis.renderer.labels.template.dy = -8;
      categoryAxis.renderer.labels.template.dx = -10;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      let maxValue = 0;
      if (chart.data.length > 0) {
        maxValue = chart.data[0].gap;
        maxValue = Math.ceil(maxValue / 100) * 100;
      }
      valueAxis.renderer.opposite = false;
      valueAxis.renderer.labels.template.fill = am4core.color(_this.dark ? '#fff' : '#000');
      // Create series
      function createSeries(field, name) {
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = 'category';
        series.name = name;
        series.columns.template.tooltipText = '{name}:[bold]{valueX}[/]';

        series.columns.template.events.on(
          'hit',
          (ev) => {
            _this.handleFocusOut();
            var elements = document.querySelectorAll('.add-fudget-form');
            elements.forEach(function (element) {
              element.classList.add('d-none');
            });
            const topCat = [
              'mortgage_and_rent',
              'vehicle_purchase_and_lease',
              'other_debt_payments',
              'savings',
              'health_insurance',
            ];
            if (topCat.includes(ev.target._dataItem._dataContext.category_type)) {
              setTimeout(() => {
                _this.activeTab = ['Your Major Expenses'];
              }, 400);
              _this.visibleCoreExp = true;
              _this.visibleCoreExpCat = true;
            } else if (common_monthly_short.includes(ev.target._dataItem._dataContext.category_type)) {
              setTimeout(() => {
                _this.activeTab = ['Common Monthly Bills'];
              }, 400);
              _this.visibleOtherExpCat = true;
            } else {
              setTimeout(() => {
                _this.activeTab = ['Other Discretionary Expenses'];
              }, 400);
              _this.visiblePersComp = true;
            }
            setTimeout(() => {
              scrollIntoView(document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card`), {
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
              });
              if (ev.target._dataItem._dataContext.category_type != 'other_debt_payments') {
                setTimeout(() => {
                  var element = document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card_click`);
                  element.classList.remove('d-none');
                }, 200);
              }
            }, 400);
          },
          this
        );
        series.columns.template.height = am4core.percent(200);
        series.sequencedInterpolation = true;
        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = '[bold]{valueX}[/]';
        valueLabel.label.horizontalLeft = 'left';
        if (window.innerWidth < 767) {
          valueLabel.label.dx = -15;
          valueLabel.label.fontSize = 13;
        } else {
          valueLabel.label.dx = 20;
        }
        valueLabel.label.hideOversized = false;
        valueLabel.label.truncate = false;
        valueLabel.label.tooltipText = '{valueX}';
        valueLabel.label.fill = am4core.color(_this.dark ? '#fff' : '#000');
        if (window.innerWidth < 767) {
          valueLabel.label.fill = am4core.color(_this.dark ? '#fff' : '#fff');
        } else {
          valueLabel.label.fill = am4core.color(_this.dark ? '#fff' : '#000');
        }
        series.legendSettings.labelText = name;
        series.columns.template.adapter.add('fill', (fill, target) => {
          if (
            _this.mortgage_and_rent_input_value &&
            target.dataItem.categories.categoryY === 'Rent or Mortgage Payment'
          ) {
            return am4core.color('#0267e8');
          }
          if (_this.vehicle_purchase_and_lease_input_value && target.dataItem.categories.categoryY === 'Car Payments') {
            return am4core.color('#0267e8');
          }
          if (_this.health_insurance_input_value && target.dataItem.categories.categoryY === 'Health Insurance') {
            return am4core.color('#0267e8');
          }
          if (_this.debt_input_value && target.dataItem.categories.categoryY === 'Other Debt Payments & Obligations') {
            return am4core.color('#0267e8');
          }
          if (_this.savings_value && target.dataItem.categories.categoryY === 'Amount to Savings Each Period') {
            return am4core.color('#0267e8');
          }
          return dataArray.includes(
            Object.keys(transformer_38).find((item) => transformer_38[item] === target.dataItem.categories.categoryY)
          )
            ? am4core.color('#0267e8')
            : am4core.color('#1aa59b');
        });
      }
      createSeries('gap', 'Difference');
      chart.responsive.enabled = true;
      chart.maintainAspectRatio = false;

      return chart;
    },
    sumBudgetValues(obj) {
      var sum = 0;
      for (var el in obj) {
        if (obj.hasOwnProperty(el)) {
          sum += parseFloat(obj[el].monthly);
        }
      }
      return sum;
    },
    checkStatus() { },
    updateChartsCached: _.debounce(async function () {
      if (this.age < 18 || this.household_members < 1) {
        this.is_typing = false;
        this.api_updates_pending = false;
        return false;
      }
      this.api_updates_pending = true;
      const demographics = this.demographicsCached;
      const budget = this.budgetCached;
      const scores = this.scoresCached;
      const lendingScore = this.lendingScoreCached;
      this.peer_income = this.sumBudgetValues(demographics);
      const comparison = this.mergeResponses(demographics, budget);
      const fullData = this.mergeResponses(demographics, budget);
      this.barChart = comparison;
      this.filtered_barchart = fullData.map((v) => Object.assign(v));
      const peerSaving = demographics.find((item) => item.category === 'Amount to Savings Each Period');
      this.peers_input_value = peerSaving.monthly;
      const chart1Data = budget.map((item) => ({
        ...item,
        type: transformer_category[item.category_type].type,
      }));
      const chart2Data = demographics.map((item, k) => ({
        ...item,
        type: transformer_category[budget[k].category_type].type,
      }));
      const chart1 = this.getPieChartData(chart1Data);
      const chart2 = this.getPieChartData(chart2Data);
      this.chart3Data = chart1;
      this.chart4Data = chart2;
      const standardChart = [
        {
          category: 'Needs',
          monthly: 50,
        },
        {
          category: 'Wants',
          monthly: 30,
        },
        {
          category: 'Financial Goals',
          monthly: 20,
        },
      ];
      this.updatePieChart(chart1, this.pie_chart3);
      this.updatePieChart(chart2, this.pie_chart4);
      this.updatePieChart(standardChart, this.pie_chart5);
      this.updateSpeedChart(scores.breakeven);
      const _this = this;
      if (this.pie_chart) {
        this.pie_chart.dispose();
      }
      this.pie_chart = this.createPieChart(budget, 'piechart');
      this.updateBarChart(comparison);
      setTimeout(() => {
        this.openProjectedGrowth();
      }, 400);
      this.scores = scores;
      this.lending_score = lendingScore;
      this.is_typing = false;
      this.api_updates_pending = false;
      this.changeFilter(this.sortDefault);
    }, 500),
    updateCharts: _.debounce(async function () {
      if (this.age < 18 || this.household_members < 1) {
        this.is_typing = false;
        this.api_updates_pending = false;
        return false;
      }
      this.api_updates_pending = true;
      const { demographics, budget, scores, lendingScore } = await this.callAPIs();
      this.demographicsCached = demographics;
      this.budgetCached = budget;
      this.scoresCached = scores;
      this.lendingScoreCached = lendingScore;
      this.peer_income = this.sumBudgetValues(demographics);
      const comparison = this.mergeResponses(demographics, budget);
      const fullData = this.mergeResponses(demographics, budget);
      this.barChart = comparison;
      this.filtered_barchart = fullData.map((v) => Object.assign(v));
      const peerSaving = demographics.find((item) => item.category === 'Amount to Savings Each Period');
      this.peers_input_value = peerSaving.monthly;

      const chart1Data = budget.map((item) => ({
        ...item,
        type: transformer_category[item.category_type].type,
      }));
      const chart2Data = demographics.map((item, k) => ({
        ...item,
        type: transformer_category[budget[k].category_type].type,
      }));
      const chart1 = this.getPieChartData(chart1Data);
      const chart2 = this.getPieChartData(chart2Data);
      this.chart3Data = chart1;
      this.chart4Data = chart2;
      const standardChart = [
        {
          category: 'Needs',
          monthly: 50,
        },
        {
          category: 'Wants',
          monthly: 30,
        },
        {
          category: 'Financial Goals',
          monthly: 20,
        },
      ];
      this.updatePieChart(chart1, this.pie_chart3);
      this.updatePieChart(chart2, this.pie_chart4);
      this.updatePieChart(standardChart, this.pie_chart5);
      this.updateSpeedChart(scores.breakeven);
      const _this = this;
      if (this.pie_chart) {
        this.pie_chart.dispose();
      }
      this.pie_chart = this.createPieChart(budget, 'piechart');
      this.updateBarChart(comparison);
      setTimeout(() => {
        this.openProjectedGrowth();
      }, 400);
      this.scores = scores;
      if (!_.isEqual(this.lending_score, lendingScore)) {
        this.lending_score = lendingScore;
      }
      this.is_typing = false;
      this.api_updates_pending = false;
      this.changeFilter(this.sortDefault);
    }, 400),

    mergeResponses(demographics, budget) {
      let comparison = [];
      const keys = demographics.map((x) => x.category);
      keys.forEach((key) => {
        comparison.push({
          category: key,
          category_type: budget.find((x) => x.category == key).category_type,
          isActive: budget.find((x) => x.category == key).isActive,
          peer_monthly: demographics.find((x) => x.category == key).monthly,
          user_monthly: budget.find((x) => x.category == key).monthly,
        });
      });
      return comparison;
    },

    async callAPIs() {
      let [lendingScore] = await Promise.all([this.callLendingScoreAPI()]);
      if (lendingScore) {
        const classs = lendingScore
          ? this.grade_to_css_class(this.score_to_grade(lendingScore.elements.cash_excess / 12))
          : {};
        this.grade_class = Object.keys(classs).find((item) => classs[item] === true);

        var monthly_cash_excess = (lendingScore && lendingScore.elements.cash_excess) || 0;
        this.lending_score_cash_excess_formattedNonFormat =
          parseInt(monthly_cash_excess) < 0 ? 0 : parseInt(monthly_cash_excess);
      }
      let [demographics, budget, scores] = await Promise.all([
        this.callDemographicsAPI(),
        this.callBudgetAPI(),
        this.callScoringAPI(),
      ]);
      return {
        demographics: demographics,
        budget: budget,
        scores: scores,
        lendingScore: lendingScore,
      };
    },
    async updatePieChart2(newData) {
      this.pie_chart2.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        this.pie_chart2.series.values[0].children.values[5].show();
      }, 400);
      this.pie_chart2.data.map((x) => {
        let updated = R.find(R.propEq('category', x.category), newData);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly;
        x.annual = updated.annual;
        return x;
      });
      this.pie_chart2.invalidateRawData();
    },
    async updateSpeedChart(value) {
      this.speed_chart.radarContainer._children._values[5].fill = am4core.color(this.dark ? '#fff' : '#000');
      let hand = this.speed_chart.hands._values[0];
      new am4core.Animation(
        hand,
        {
          property: 'value',
          to: this.roundSpeedValue(parseFloat(value)),
        },
        1000,
        am4core.ease.cubicOut
      ).start();
    },
    async updatePieChart(newData, pie_chart_type) {
      const _this = this;
      if (!pie_chart_type) {
        return false;
      }
      pie_chart_type.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        pie_chart_type.series.values[0].children.values[5].show();
      }, 400);
      pie_chart_type.series.values[0].children.values[5].fill = am4core.color(this.dark ? '#fff' : '#000');
      /* eslint-disable */
      let da = newData.map((item) => ({
        ...item,
        dol: Math.trunc((_this.netAmountInput.replace(/[^\d\.\-]/g, '') * item.monthly) / 100),
      }));
      pie_chart_type.data.map((x) => {
        let updated = R.find(R.propEq('category', x.category), da);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly >= 0 ? updated.monthly : 0;
        x.annual = updated.annual;
        x.dol = updated.dol;
        return x;
      });
      pie_chart_type.series.values[0].children.values[5].marginTop = pie_chart_type.chartContainer.pixelHeight / 2;
      pie_chart_type.series.values[0].children.values[5].marginLeft = pie_chart_type.chartContainer.pixelWidth / 2;
      pie_chart_type.series.values[0].children.values[5].horizontalCenter = 'middle';
      pie_chart_type.series.values[0].children.values[5].verticalCenter = 'middle';
      pie_chart_type.invalidateRawData();
    },
    changePeer(event) {
      this.showPeer = event;
    },
    async updateBarChart(newData) {
      if (this.bar_chart) {
        this.bar_chart.dispose();
      }
      this.bar_chart = this.createBarChart(newData);
    },
    async updateChart() {
      this.chart.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        this.chart.series.values[0].children.values[5].show();
      }, 400);
      let newData = await this.callBudgetAPI();
      this.chart.data.map((x) => {
        let updated = R.find(R.propEq('category', x.category), newData);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly;
        x.annual = updated.annual;
        return x;
      });
      this.chart.invalidateRawData();
    },
    async recategorizePieChart(data) {
      this.pie_chart.data = data;
    },
    async recategorizePieChart2(data) {
      this.pie_chart2.data = data;
    },
    async callBudgetAPI() {
      const changed = this.changedValues;
      const URI = 'https://api.spendid.io/v1.0/budgets/generate';
      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
      };
      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income: this.monthly_take_home_net * 12,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: '35210',
          is_homeowner: false,
        };
        // return false
      }
      const post_data = {
        demographics: demograph,
        transformer: this.selected_transformer,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
                ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
                : null,
          other_debt_payments: this.debt_value !== null ? this.debt_value * this.debt_input_value_freq : null,
          health_insurance:
            this.health_insurance_value !== null
              ? parseInt(this.health_insurance_value) * this.health_insurance_input_value_freq
              : null,
          mortgage_and_rent:
            this.mortgage_and_rent_value !== null
              ? parseInt(this.mortgage_and_rent_value) * this.mortgage_and_rent_input_value_freq
              : null,
          vehicle_purchase_and_lease:
            this.vehicle_purchase_and_lease_value !== null
              ? this.vehicle_purchase_and_lease_value * this.vehicle_purchase_and_lease_input_value_freq
              : null,
          ...this.eliminated,
        },
      };
      const mainData = {
        net_amount: this.net_amount,
        monthly_take_home: this.monthly_take_home,
        monthly_take_home_feq: this.monthly_take_home_input_value_freq,
        age: parseInt(this.age),
        household_members: parseInt(this.household_members),
        user_name: this.user_name,
        user_email: this.user_email,
        zip: this.zip,
        is_homeowner: this.is_homeowner_value,
        saving: {
          value: this.savings_value,
          freq: this.savings_input_value_freq,
        },
        other_debt_payments: {
          value: this.debt_value,
          freq: this.debt_input_value_freq,
        },
        mortgage_and_rent: {
          value: this.mortgage_and_rent_value,
          freq: this.mortgage_and_rent_input_value_freq,
        },
        vehicle_purchase_and_lease: {
          value: this.vehicle_purchase_and_lease_value,
          freq: this.vehicle_purchase_and_lease_input_value_freq,
        },
        health_insurance: {
          value: this.health_insurance_value,
          freq: this.health_insurance_input_value_freq,
        },
        rest: this.changedValuesText,
        rest2: this.changedValues,
        eliminated: this.eliminated,
        billSectionShow: this.billSectionShow,
        debtData: {
          month_debs: this.month_debs,
          otherDebtPayments: this.otherDebtPayments,
          creditDebtPayment: this.creditDebtPayment,
          studentLoan: this.studentLoan,
          alimonyPayments: this.alimonyPayments,
          homeEquityPayment: this.homeEquityPayment,
          childSupportPayments: this.childSupportPayments,
          estimatedTaxPayments: this.estimatedTaxPayments,
        },
      };
      try {
        this.$cookies.set('storedData', mainData);
      } catch {
        // eslint-disable-next-line no-console
      }
      const result = await this.$http.post(URI, post_data, config);
      this.apiReq = post_data;
      this.callBudgetAPIRes = result.data;
      const api_model = Object.entries(result.data.transformed).map(([category, annual]) => ({
        category,
        annual,
      }));
      const bud = Object.entries(result.data.budget).map(([category, annual]) => ({
        category,
        annual,
        bud,
      }));
      const eliminated = Object.entries(this.eliminated).map(([category]) => category);
      const budget = api_model.map((x) => {
        const key = Object.keys(transformer_38).find((item) => transformer_38[item] === x.category);
        return {
          category: x.category,
          category_type: key,
          annual: Math.round(x.annual),
          monthly: Math.round(x.annual / 12),
          weekly: Math.round(x.annual / 52),
          isActive: !eliminated.includes(key),
        };
      });
      return budget;
    },
    async callScoringAPI() {
      const changed = this.changedValues;
      const URI = 'https://api.spendid.io/v1.0/scores/generate';
      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
      };

      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income: this.monthly_take_home_net * 12,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: '35210',
          is_homeowner: false,
        };
        // return false
      }
      const post_data = {
        demographics: demograph,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
                ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
                : null,
          other_debt_payments: this.debt_value !== null ? this.debt_value * this.debt_input_value_freq : null,
          health_insurance:
            this.health_insurance_value !== null
              ? this.health_insurance_value * this.health_insurance_input_value_freq
              : null,
          ...this.eliminated,
        },
      };
      if (this.mortgage_and_rent_value !== null) {
        post_data.budget['mortgage_and_rent'] =
          parseInt(this.mortgage_and_rent_value) * this.mortgage_and_rent_input_value_freq;
      }
      if (this.vehicle_purchase_and_lease_value !== null) {
        post_data.budget['vehicle_purchase_and_lease'] =
          this.vehicle_purchase_and_lease_value * this.vehicle_purchase_and_lease_input_value_freq;
      }

      const result = await this.$http.post(URI, post_data, config);
      this.callScoringAPIRes = result.data;
      const val = {
        breakeven: (Math.round((result.data.breakeven || 0) * 100) / 100).toFixed(1),
        saving: (Math.round((result.data.saving || 0) * 100) / 100).toFixed(1),
        lending: (Math.round((result.data.lending || 0) * 100) / 100).toFixed(1),
      };
      return val;
    },
    async callLendingScoreAPI() {
      const changed = this.changedValues;
      const URI = 'https://api.spendid.io/v1.0/scores/lending';
      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
      };

      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income: this.monthly_take_home_net * 12,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: '35210',
          is_homeowner: false,
        };

        // return false
      }

      const post_data = {
        demographics: demograph,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
                ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
                : null,
          other_debt_payments: this.debt_value !== null ? this.debt_value * 12 : null,
          health_insurance:
            this.health_insurance_value !== null
              ? this.health_insurance_value * this.health_insurance_input_value_freq
              : null,
          ...this.eliminated,
        },
      };

      if (this.mortgage_and_rent_value !== null) {
        post_data.budget['mortgage_and_rent'] =
          parseInt(this.mortgage_and_rent_value) * this.mortgage_and_rent_input_value_freq;
      }
      if (this.vehicle_purchase_and_lease_value !== null) {
        post_data.budget['vehicle_purchase_and_lease'] =
          this.vehicle_purchase_and_lease_value * this.vehicle_purchase_and_lease_input_value_freq;
      }

      const result = await this.$http.post(URI, post_data, config);
      this.callLendingScoreAPIRes = result.data;
      return result.data;
    },
    async callDemographicsAPI() {
      window.localStorage.setItem('saveReport', 'no');
      let trasformer = this.selected_transformer;
      const URI = 'https://api.spendid.io/v1.0/demographics/models/generate';

      const config = {
        headers: { 'x-api-key': 'HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr' },
      };
      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income: this.monthly_take_home_net * 12,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: '35210',
          is_homeowner: false,
        };

        // return false
      }

      const post_data = {
        demographics: demograph,
        transformer: trasformer,
      };

      const result = await this.$http.post(URI, post_data, config);
      this.callDemographicsAPIRes = result.data;
      // hack to add a debt payment option
      const api_model = Object.entries(result.data.transformed).map(([category, annual]) => ({
        category,
        annual,
      }));

      const demographics = api_model.map((x) => {
        return {
          category: x.category,
          // category_type: bud[i].category,
          annual: Math.round(x.annual),
          monthly: Math.round(x.annual / 12),
          weekly: Math.round(x.annual / 52),
          isActive: false,
        };
      });
      this.demographics_response = demographics;
      return demographics;
    },
  },
};
</script>

<template>
  <div :class="{
    // darkmode: dark,
    'open-sidebar': openSidebar,
    'no-result':
      !checkForValidate() ||
      debt_value === null ||
      !(debt_value >= 0) ||
      vehicle_purchase_and_lease_value === null ||
      !(vehicle_purchase_and_lease_value >= 0) ||
      mortgage_and_rent_value === null ||
      !(mortgage_and_rent_value >= 0) ||
      health_insurance_value === null ||
      !(health_insurance_value >= 0),
  }">
    <div :class="{ 'd-none': page != 'main' }">
      <router-view />
      <div class="left-body-part">
        <sidebar :dark="dark" :activeTab="activeTab" :stepForm="false" :showPeer="showPeer" :stepEnable="stepEnable"
          :collapsedChecked="collapsedChecked" :dataLoading="api_updates_pending || !checkForValidate()"
          :showResult="checkForValidate()" v-on:toggleSidebar="toggleSidebar" v-on:fillAutoData="fillAutoData" />
      </div>

      <div class="right-body-part" :class="{ 'is-demo': inDemo }">
        <Navbar v-if="!stepEnable" :openSidebar="openSidebar" :dark="dark" :activeTab="activeTab" :stepForm="false"
          :showPeer="showPeer" :stepEnable="stepEnable" :collapsedChecked="collapsedChecked"
          :dataLoading="api_updates_pending || !checkForValidate()" :showResult="checkForValidate()"
          v-on:toggleSidebar="toggleSidebar" v-on:fillAutoData="fillAutoData" />
        <div class="position-relative login-popup">
          <b-table style="display: none" id="printtable" striped hover></b-table>

          <div v-if="!isActive" class="print-loader">
            <div class="print-loader-message">
              <div>
                <h3 style="margin-bottom: 40px">
                  <span class="visible-md">Downloading</span>
                  <span class="hidden-md">Preparing</span>
                  Report
                </h3>
                <vue-ellipse-progress :progress="percentage" />
                <h5 style="margin-top: 40px">Preparing your report</h5>
                <h5>
                  It will take some time to prepare and
                  <span class="visible-md">download</span>
                  <span class="hidden-md">email</span>
                  your statement, Please be patient
                </h5>
              </div>
            </div>
          </div>

          <b-form @submit="onSubmit" id="gtm-tag">
            <section id="live-demo">
              <stepform v-if="stepEnable" :byPass="byPass" :dark="dark" v-on:submitStepForm="submitStepForm"
                v-on:fillAutoData="fillAutoData" v-on:stepEnable="stepEnable = false" />
              <div class="stepdiv" :class="{
                'd-none': stepEnable == true,
                'all-expand': collapsedChecked,
              }">
                <div :class="{ 'd-none': activeTab.includes('How To') }">
                  <div id="my-profile-page" class="my-profile-page tab-design" :class="{
                    'close-tab': !activeTab.includes('Your Profile'),
                  }">
                    <div class="headline-title">
                      <div class="d-inline-block headline-collapse">
                        <button type="button" class="font-urbanerounded-bold" @click="
                          activeTab = !activeTab.includes('Your Profile') ? ['Your Profile'] : [''];
                        collapsedChecked = false;
                        ">
                          <i class="fa fa-caret-down arrow-collapse"></i>
                          Profile
                        </button>
                      </div>
                    </div>
                    <div class="all_tab_data">
                      <div class="first-block-data">
                        <!-- <div class="profile-image bg-background mb-3">
                          <img alt="profile-image"
                            :src="`https://biz.spendid.io/api/get-image/${userId}?ver=${Math.random()}`"
                            class="img-fluid" />
                        </div> -->
                        <div class="custom-form-control zipcode-dropdown mb-3" style="z-index: 1">
                          <template>
                            <div class="row">
                              <legend class="bv-no-focus-ring col-form-label pt-0 col-6 col-md-4 col-lg-12">
                                5-Digit Zip Code
                              </legend>
                              <div class="col-6 col-md-8 col-lg-12 has-icons-right">
                                <div class="position-relative">
                                  <b-form-input placeholder="Enter here" v-model="zipCode" @input="handleSearchChange"
                                    @focusin="showDropdown" @focusout="hideDropdown" pattern="\d*" type="number"
                                    maxlength="5" autocomplete="on"
                                    class="position-relative input-capitalize big-input-font"></b-form-input>
                                  <!-- <ul
                                v-if="filteredZipCodes.length && dropdownOpen"
                                class="dropdown-menu-ul show"
                                @mousedown.prevent
                              >
                                <li
                                  v-for="(zip, index) in filteredZipCodes"
                                  :key="index"
                                  @click="selectZip(zip)"
                                  class="dropdown-item"
                                >
                                  {{ zip['Zip Code'] }} {{ zip['City'] }},
                                  {{ zip['State'] }}
                                </li>
                              </ul>
                              <ul
                                v-if="filteredZipCodes.length == 0 && dropdownOpen"
                                class="dropdown-menu-ul no-element-dropdown show"
                                @mousedown.prevent
                              >
                                <li class="dropdown-item">No elements found. Consider changing the search query.</li>
                              </ul> -->
                                  <span class="check icon is-small is-right">
                                    <i v-if="is_typing" class="fas fa-cog fa-spin" style="opacity: 0.5"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>

                        <div class="double-data">
                          <div class="custom-form-control d-block mb-3">
                            <div class="row">
                              <legend class="bv-no-focus-ring col-form-label pt-0 col-6 col-md-4">City</legend>
                              <div class="col-6 col-md-8">
                                <b-form-input size="sm" placeholder="" :class="{
                                  asa:
                                    zip_codes.find((item) => item['Zip Code'] === zip) &&
                                    zip_codes.find((item) => item['Zip Code'] === zip),
                                }" disabled :value="zip_codes.find((item) => item['Zip Code'] === zip) &&
                                  zip_codes.find((item) => item['Zip Code'] === zip)['City']
                                  " type="text" class="position-relative dis no-border-input"></b-form-input>
                              </div>
                            </div>
                          </div>
                          <div class="custom-form-control d-block mb-3">
                            <div class="row">
                              <legend class="bv-no-focus-ring col-form-label pt-0 col-6 col-md-4">State</legend>
                              <div class="col-6 col-md-8">
                                <b-form-input placeholder="" size="sm" disabled :class="{
                                  asa:
                                    zip_codes.find((item) => item['Zip Code'] === zip) &&
                                    state_gross.find(
                                      (it) =>
                                        it.abbreviation === zip_codes.find((item) => item['Zip Code'] === zip)['State']
                                    ),
                                }" :value="zip_codes.find((item) => item['Zip Code'] === zip) &&
                                  state_gross.find(
                                    (it) =>
                                      it.abbreviation === zip_codes.find((item) => item['Zip Code'] === zip)['State']
                                  ).state
                                  " type="text" class="position-relative dis no-border-input"></b-form-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="custom-form-control d-block mb-3">
                          <div class="row">
                            <legend class="has-icons-right col-form-label pt-0 col-6 col-md-4 col-lg-12">Age</legend>
                            <div class="col-6 col-md-8 col-lg-12 has-icons-right">
                              <div class="position-relative">
                                <b-form-input placeholder="Enter here" v-model="age" type="number" pattern="\d*"
                                  @blur="focusOut($event)" autocomplete="on"
                                  class="position-relative input-capitalize big-input-font"></b-form-input>
                                <span class="text-danger small d-block mt-1" v-if="age < 18">(Must be 18+)</span>
                                <span class="check icon is-small is-right">
                                  <i v-if="is_typing" class="fas fa-cog fa-spin" style="opacity: 0.5"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <b-form-group label="Housing Type" v-slot="{ ariaDescribedby }"
                          class="custom-form-control  double-input">
                          <div class="inputGroup">
                            <input v-model="is_homeowner" type="radio" :checked="!is_homeowner" @change="onOwnerChange"
                              :name="`housing-type-radio`" :value="`${home_options[0].value}`"
                              :id="`housing${home_options[0].text}`" />
                            <label :for="`housing${home_options[0].text}`">
                              <span class="">Rent</span>
                            </label>
                          </div>
                          <div class="inputGroup">
                            <input v-model="is_homeowner" type="radio" :checked="is_homeowner" @change="onOwnerChange"
                              :name="`housing-type-radio`" :value="`${home_options[1].value}`"
                              :id="`housing1${home_options[1].text}`" />
                            <label :for="`housing1${home_options[1].text}`">
                              <span class="">Buy</span>
                            </label>
                          </div>
                        </b-form-group>

                        <b-form-group label="Number of People In Household"
                          class="custom-form-control step-slider has-icons-right">
                          <span class="text-danger small d-block" v-if="household_members < 1">
                            (Your household must be min 1.)
                          </span>
                          <vue-slider v-model="household_members" :data="data" :marks="true" :data-value="'id'"
                            :data-label="'name'" :dot-options="dotOptions" class="mt-3"></vue-slider>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="tab-footer d-flex justify-content-end">
                      <button type="button" v-if="!inDemo" @click="
                        activeTab = ['Income'];
                      scrollToSection('Income');
                      " class="next-cta">
                        Next
                        <i class="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>

                  <div id="my-income-page" class="my-income-page tab-design"
                    :class="{ 'close-tab': !activeTab.includes('Income') }">
                    <div class="headline-title d-flex justify-content-between mobile-part-price">
                      <div class="d-inline-block headline-collapse">
                        <button type="button" class="font-urbanerounded-bold" @click="
                          activeTab = !activeTab.includes('Income') ? ['Income'] : [''];
                        collapsedChecked = false;
                        ">
                          <i class="fa fa-caret-down arrow-collapse"></i>
                          Income
                        </button>
                      </div>

                      <div class="right-part-headline d-none d-md-block">
                        <template>
                          <div class="total_monthly_inc text-capitalize text-center text-md-right">
                            {{
                              net_amount.length == net_amount.filter((item) => item.grossOrNet == 'net').length
                                ? 'Estimated'
                                : net_amount.length == net_amount.filter((item) => item.grossOrNet == 'gross').length
                                  ? 'Total'
                                  : 'Estimated'
                            }}
                            Monthly Gross Income
                            <span class="income-amount">{{ monthly_take_home_input_value }}</span>
                          </div>
                          <div class="total_monthly_inc mt-1 text-capitalize text-center text-md-right">
                            {{
                              net_amount.length == net_amount.filter((item) => item.grossOrNet == 'net').length
                                ? 'Total'
                                : 'Estimated'
                            }}
                            Take-Home Income
                            <span class="income-amount">{{ netAmountInput }}</span>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div class="all_tab_data">
                      <b-row v-if="zip && zip.length === 5">
                        <b-col cols="12" md="12" :lg="occupationAIText.length > 0 || occupationAILoad ? '6' : '12'">
                          <div class="multiple-blocks" v-if="!income_method_val">
                            <b-card no-header no-body
                              :style="occupationAIText.length > 0 || occupationAILoad ? 'width:50%' : 'width:25%'"
                              class="result-profile-innercard profile-innercard no-box-shadow border-0 bg-transparent p-2 p-lg-3"
                              v-for="(amt_freq, counter) in net_amount" :key="counter">
                              <div
                                class="result-profile-innercard-header d-flex align-items-center border-0 justify-content-between p-0">
                                <h4 class="profile-innercard-title">
                                  Source #{{ counter + 1 }}
                                  <!-- <span>(Frequency)</span> -->
                                </h4>
                                <span v-if="net_amount.length > 1" @click="deleteIncome(counter)"
                                  class="text-danger cursor-pointer d-inline-block font-weight-bold far fa-times-circle"></span>
                              </div>

                              <div class="result-profile-innercard-body p-0">
                                <div class="income-method-inner p-2 mt-2 mt-lg-3 mb-3 mb-lg-4">
                                  <div class="inputGroup mb-2">
                                    <input @change="incomeChange(counter, net_amount[counter].manual)"
                                      v-model="net_amount[counter].manual" type="radio"
                                      :name="`income_method${counter}`" value="2" :id="`grossradioOption${counter}`" />
                                    <label :for="`grossradioOption${counter}`">
                                      <span class="">Manual Input</span>
                                    </label>
                                  </div>

                                  <div class="inputGroup">
                                    <input @change="incomeChange(counter, net_amount[counter].manual)"
                                      v-model="net_amount[counter].manual" type="radio"
                                      :name="`income_method${counter}`" value="1" :id="`incomeradioOption${counter}`" />
                                    <label :for="`incomeradioOption${counter}`">
                                      <span class="">Occupation</span>
                                    </label>
                                  </div>
                                </div>

                                <template v-if="amt_freq.manual != '2'">
                                  <div class="income-method-inner append-design border-0 bg-transparent p-0">
                                    <div class="custom-form-control">
                                      <div class="d-flex align-items-center">
                                        <label class="col-form-label">Occupation Selector</label>
                                        <div v-if="net_amount[counter].manual == '1' && occupationAIText.length > 0"
                                          class="hover-info-box occupation-hover-info d-none d-md-block">
                                          <span class="hover-icon d-inline-block ml-2">
                                            <i class="far fa-question-circle"></i>
                                          </span>
                                          <div v-if="!occupationAILoad" class="hover-info position-left">
                                            <div class="mb-3" v-for="(aidata, i) in occupationAIText" :key="i">
                                              <div class="">
                                                <h2>{{ aidata.title }}</h2>
                                              </div>
                                              <div class=" ">
                                                <div class="ai-response-profile-card-body-content mt-2"
                                                  v-for="(insights, j) in aidata.detail" :key="j">
                                                  <h3>
                                                    {{ insights.title }}
                                                  </h3>
                                                  <ul class="ai-response-profile-list mt-2">
                                                    <li>
                                                      {{ insights.detail }}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else class="hover-info position-left">
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                              <div class="loader-ai"></div>
                                              <p class="mb-0 mt-2">Loading, Please Wait...</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <b-form-group class="custom-form-control">
                                      <Multiselect placeholder="Search" v-model="net_amount[counter].occupation"
                                        @select="
                                          levelChange(
                                            counter,
                                            net_amount[counter].level,
                                            net_amount[counter].occupation,
                                            true
                                          )
                                          " @remove="
                                            levelChange(
                                              counter,
                                              net_amount[counter].level,
                                              net_amount[counter].occupation,
                                              true
                                            )
                                            " :options="occupations.map((item) => item.id)"></Multiselect>
                                    </b-form-group>
                                    <b-form-group label="Annual Gross Salary Level" class="custom-form-control">
                                      <b-form-radio-group :disabled="!net_amount[counter].occupation"
                                        v-model="net_amount[counter].level" :options="annual_gross_salary_level"
                                        @change="
                                          levelChange(
                                            counter,
                                            net_amount[counter].level,
                                            net_amount[counter].occupation
                                          )
                                          " :name="`annual-gross-radio-${counter}`" class="mt-0"
                                        stacked></b-form-radio-group>
                                    </b-form-group>
                                    <b-form-group label="Amount (Annual Gross)" class="custom-form-control">
                                      <b-form-input v-model.lazy="amt_freq.amount" v-money="money" disabled type="text"
                                        pattern="\d*" autocomplete="on"
                                        class="position-relative big-input-font"></b-form-input>
                                    </b-form-group>
                                  </div>
                                </template>

                                <template v-else>
                                  <div class="income-method-inner append-design border-0 bg-transparent p-0">
                                    <b-row>
                                      <b-col cols="5" md="5">
                                        <b-form-group label="Amount" class="custom-form-control">
                                          <b-form-input v-model.lazy="amt_freq.amount" v-money="money"
                                            @blur="onSeourceSelect(counter)" type="text" pattern="\d*" autocomplete="on"
                                            class="position-relative big-input-font"
                                            placeholder="Type your answer here..."></b-form-input>
                                        </b-form-group>
                                      </b-col>
                                      <b-col cols="7" md="7">
                                        <div class="gross-net-home-radios mt-2">
                                          <div class="inputGroup mb-2">
                                            <input type="radio" :name="`radio-inline1-${counter}`" value="gross"
                                              @click="onSeourceSelect(counter, false)"
                                              v-model="net_amount[counter].grossOrNet"
                                              :id="`incomeradioOption1-${counter}`" />
                                            <label :for="`incomeradioOption1-${counter}`">
                                              <span class="">Gross</span>
                                            </label>
                                          </div>
                                          <div class="inputGroup mb-2">
                                            <input type="radio" :name="`radio-inline1-${counter}`" value="net"
                                              @click="onSeourceSelect(counter, false)"
                                              v-model="net_amount[counter].grossOrNet"
                                              :id="`grossradioOption1-${counter}`" />
                                            <label :for="`grossradioOption1-${counter}`">Net "Take Home"</label>
                                          </div>
                                        </div>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col>
                                        <b-form-group label="Frequency" class="custom-form-control">
                                          <b-form-select v-on:keyup.once="amt_freq.freq = $event.target.value"
                                            @change="onSeourceSelect(counter)" v-model.lazy="amt_freq.freq"
                                            :options="frequencyOptionsNew" :value="null"
                                            class="big-input-font"></b-form-select>
                                        </b-form-group>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </template>
                              </div>
                            </b-card>

                            <div v-if="net_amount.length < 4"
                              :style="occupationAIText.length > 0 || occupationAILoad ? 'width:50%' : 'width:25%'"
                              class="card result-profile-innercard profile-innercard no-box-shadow border-0 bg-transparent p-2 p-lg-3">
                              <div
                                class="result-profile-innercard-header d-flex align-items-center border-0 justify-content-between p-0">
                                <h4 class="profile-innercard-title">Source #{{ net_amount.length + 1 }}</h4>
                              </div>

                              <div class="add_more result-profile-innercard-actions mt-2 mt-lg-3" @click="addIncome()">
                                <span><i class="fa fa-plus"></i></span>
                                <p>Add More</p>
                              </div>
                            </div>
                            <div class="right-part-headline mx-2 d-block d-md-none">
                              <template>
                                <div class="total_monthly_inc text-capitalize text-center text-md-right">
                                  {{
                                    net_amount.length == net_amount.filter((item) => item.grossOrNet == 'net').length
                                      ? 'Estimated'
                                      : net_amount.length ==
                                        net_amount.filter((item) => item.grossOrNet == 'gross').length
                                        ? 'Total'
                                        : 'Estimated'
                                  }}
                                  Monthly Gross Income
                                  <span class="income-amount">{{ monthly_take_home_input_value }}</span>
                                </div>
                                <div class="total_monthly_inc mt-1 text-capitalize text-center text-md-right">
                                  {{
                                    net_amount.length == net_amount.filter((item) => item.grossOrNet == 'net').length
                                      ? 'Total'
                                      : 'Estimated'
                                  }}
                                  Take-Home Income
                                  <span class="income-amount">{{ netAmountInput }}</span>
                                </div>
                              </template>
                            </div>
                          </div>
                        </b-col>
                        <b-col cols="12" md="12" :lg="occupationAIText.length > 0 || occupationAILoad ? '6' : '12'">
                          <div v-if="!occupationAILoad"
                            class="bg-transparent ai-response-profile-card-outer ai-overflow-y d-flex">
                            <b-card no-header no-body
                              class="ai-response-profile-card no-box-shadow border-radius-10 border-radius-10 mb-3 mr-2"
                              v-for="(aidata, i) in occupationAIText" :key="i">
                              <div class="ai-response-profile-card-header">
                                <h2>{{ aidata.title }}</h2>
                              </div>
                              <div class="ai-response-profile-card-body">
                                <div class="ai-response-profile-card-body-content"
                                  v-for="(insights, j) in aidata.detail" :key="j">
                                  <h3>{{ insights.title }}</h3>
                                  <ul class="ai-response-profile-list mt-2">
                                    <li>
                                      {{ insights.detail }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </b-card>
                          </div>
                          <b-card v-else no-header no-body
                            class="ai-response-profile-card no-box-shadow border-radius-10 mb-3 d-none d-md-block">
                            <div class="ai-response-profile-card-body ai-response-min-height">
                              <div class="text-center w-100 ai-response-min-height">
                                <div
                                  class="d-flex flex-column align-items-center justify-content-center ai-response-min-height">
                                  <div class="loader-ai"></div>
                                  <p class="mb-0 mt-2">Loading, Please Wait...</p>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row v-else class="justify-content-center">
                        <b-col>
                          <h4 class="text-center text-danger">Zip Code required in Profile</h4>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="tab-footer d-flex justify-space-between">
                      <button type="button" v-if="!inDemo" @click="
                        activeTab = ['Your Profile'];
                      scrollToSection('Your Profile');
                      " class="back-cta">
                        <i class="fa fa-arrow-left"></i>
                        Back
                      </button>
                      <button type="button" v-if="!inDemo" @click="
                        activeTab = ['Your Major Expenses'];
                      scrollToSection('Your Major Expenses');
                      " class="next-cta">
                        Next
                        <i class="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                  <div id="my-expenses-page" class="expenses-page tab-design" :class="{
                    'close-tab': !(
                      activeTab.includes('Your Major Expenses') ||
                      activeTab.includes('Common Monthly Bills') ||
                      activeTab.includes('Other Discretionary Expenses')
                    ),
                  }">
                    <div class="headline-title">
                      <b-row class="align-items-center">
                        <b-col sm="12" lg="4" xl="4">
                          <div class="d-flex justify-space-between">
                            <div class="d-inline-block headline-collapse">
                              <button type="button" class="font-urbanerounded-bold" @click="
                                activeTab = !activeTab.includes('Your Major Expenses')
                                  ? ['Your Major Expenses']
                                  : [''];
                              collapsedChecked = false;
                              ">
                                <i class="fa fa-caret-down arrow-collapse"></i>
                                Expenses
                              </button>
                            </div>
                            <div class="cat-edit-disable d-flex align-items-center justify-content-center">
                              <div class="d-flex align-items-center edit-legends-expense mr-2">
                                <i class="fas fa-pencil-alt"></i>
                                <span>Edit</span>
                              </div>
                              <button type="button" @click="resetDefault(false, 'noall')" class="btn btn-sm btn-danger">
                                Reset All
                              </button>
                              <!-- <div class="remove-legends-expense">
                                <i class="fas fa-minus-circle text-danger" aria-hidden="true"></i>
                                <span>Remove</span>
                              </div> -->
                            </div>
                          </div>
                        </b-col>
                        <b-col sm="7" lg="4" xl="4">
                          <div class="legends justify-content-center py-2 mb-0">
                            <div class="hover-info-box">
                              <p class="commmon-circle predict">
                                <b-button size="sm" class="btn questionsize" variant="primary">
                                  <i class="fas fa-question text-light"></i>
                                </b-button>
                                Predicted
                              </p>
                              <div class="hover-info position-left">
                                <p class="m-0 hover-info-text">
                                  Predicted by SPENDiD is our estimate of the amount required in order for the User to
                                  achieve the Predicted Saving Ability or Custom Amount to Savings (but not worse than
                                  break-even)
                                </p>
                              </div>
                            </div>
                            <p>
                              <span class="input-btn"></span>
                              input
                            </p>
                            <div class="hover-info-box">
                              <p class="commmon-circle your-peers">
                                <b-button size="sm" class="btn questionsize" variant="primary">
                                  <i class="fas fa-question text-light"></i>
                                </b-button>
                                Peers
                              </p>
                              <div class="hover-info position-right">
                                <p class="m-0 hover-info-text">
                                  Peer amounts for each expense category are calculated by SPENDiD based on the user’s
                                  demographic profile information including income, zip code, age, etc…
                                </p>
                              </div>
                            </div>
                          </div>
                        </b-col>
                        <b-col sm="5" lg="4" xl="4">
                          <div class="total_monthly_inc mt-1 text-capitalize text-center text-md-right">
                            Your Total Expenses
                            <span class="income-amount" v-if="checkForValidate()">{{ totalExpenses }}</span>
                            <span class="income-amount" v-else>$0</span>
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="all_tab_data">
                      <div class="expenses-categories p-0">
                        <div class="expenses-mobile-tabs">
                          <b-container fluid ref="third_sec" class="p-0">
                            <b-row>
                              <b-col sm="12" lg="12" xl="12">
                                <template #title>Major Expenses</template>
                                <b-card no-header no-body
                                  class="category-expenses-card major-expenses-card no-box-shadow border-radius-10 mb-3">
                                  <div class="category-expenses-card-header">
                                    <h4 class="category-expenses-card-title m-0">
                                      <i class="fas fa-money-bill mr-2"></i>
                                      Major Expenses
                                    </h4>
                                  </div>
                                  <div class="category-expenses-card-body">
                                    <div class="budget-tables" :class="{ listview: !gridSecond }">
                                      <b-row v-click-outsides="handleFocusOut" :class="{
                                        'd-none': !checkForValidate(),
                                      }">
                                        <b-col sm="12" lg="12" xl="8">
                                          <b-row>
                                            <CoreExpenseCategories :zip="zip" :age="age" :monthDebs="month_debs"
                                              :householdMembers="household_members" :grid="gridSecond"
                                              :showPeer="showPeer" @changeValue="changeValue" @submitDebt="submitDebtNo"
                                              :defaultActiveTab="defaultActiveTab"
                                              @defaultActiveTabAction="defaultActiveTabAction"
                                              @openOtherDebt="openOtherDebt" class="cat-comps"
                                              v-for="(chart, i) in filtered_barchart && filtered_barchart.slice(0, 4)"
                                              ref="coreexp" :key="i" :title="chart.category"
                                              :value1="chart.peer_monthly" :value2="chart.user_monthly"
                                              :frequencyOptions="frequencyOptions" :changedValues="changedValues"
                                              :newValueMorgage="{
                                                val: mortgage_and_rent_input_value,
                                                freq: mortgage_and_rent_input_value_freq,
                                              }" :newValueVahicle="{
                                                val: vehicle_purchase_and_lease_input_value,
                                                freq: vehicle_purchase_and_lease_input_value_freq,
                                              }" :newValueDebt="{
                                                val: debt_input_value,
                                                freq: debt_input_value_freq,
                                              }" :newValueSaving="{
                                                val: savings_input_value,
                                                freq: savings_input_value_freq,
                                              }" :newValueHealth="{
                                                val: health_insurance_input_value,
                                                freq: health_insurance_input_value_freq,
                                              }" />
                                          </b-row>
                                        </b-col>
                                        <b-col sm="12" lg="12" xl="4">
                                          <b-card no-header no-body
                                            class="category-expenses-card no-box-shadow d-none d-md-block">
                                            <div class="category-titles-card-body">
                                              <div class="bg-white p-2 border-radius-10 w-100 d-flex align-items-center"
                                                style="height:250px">
                                                <img src="imgs/logo-mini.png" alt="spendid-logo"
                                                  class="img-fluid mx-auto" style="height:200px">
                                                <!-- <img src="imgs/mybudgetreport-logo.png" alt="mybudgetreport-logo" class="img-fluid mx-auto"> -->
                                              </div>
                                            </div>
                                          </b-card>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </b-card>
                                <!-- </b-tab> -->
                              </b-col>
                              <b-col sm="12" lg="12" xl="12">
                                <template #title>Monthly Bills</template>
                                <b-card no-header no-body
                                  class="category-expenses-card monthly-bills-card no-box-shadow border-radius-10 mb-3">
                                  <div class="category-expenses-card-header">
                                    <h4 class="category-expenses-card-title m-0">
                                      <i class="fas fa-file-invoice-dollar mr-2"></i>
                                      Monthly Bills
                                    </h4>
                                  </div>
                                  <div class="category-expenses-card-body">
                                    <b-row class="el-card" :class="{
                                      'd-none': !checkForValidate(),
                                    }">
                                      <budgetComponent :zip="zip" :age="age" :householdMembers="household_members"
                                        :defaultValues="changedValuesText" :grid="gridSecond" :showPeer="showPeer"
                                        :defaultActiveTab="defaultActiveTab"
                                        @defaultActiveTabAction="defaultActiveTabAction" @event="openModelEliminate"
                                        @changeValue="changeValue" class="cat-comps" v-for="chart in filtered_barchart &&
                                          filtered_barchart.filter(
                                            (item, i) => i > 4 && item.isActive && common_monthly.includes(item.category)
                                          )" :key="chart.category" :title="chart.category" :value1="chart.peer_monthly"
                                        :value2="chart.user_monthly" :frequencyOptions="frequencyOptions" />
                                    </b-row>
                                    <div class="eliminate-category-accordion accordion-collapsed d-none" role="tablist"
                                      :class="{
                                        'd-none': !checkForValidate(),
                                      }">
                                      <b-card no-body class="card-shadow border-radius-10 ">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                          <b-button block @click="visibleDisabledCat = !visibleDisabledCat"
                                            :class="visibleDisabledCat ? null : 'collapsed'"
                                            :aria-expanded="visibleDisabledCat ? 'true' : 'false'"
                                            aria-controls="accordion-1">
                                            Removed Categories
                                            <span class="ml-1 d-inline-block fw-normal">
                                              ({{ eleMonthlyBillCount }})
                                            </span>
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-1" v-model="visibleDisabledCat"
                                          accordion="eliminate-category-accordion" role="tabpanel">
                                          <b-card-body class="w-100" :class="{ printbg: !isActive }">
                                            <div class="budget-tables w-100" :class="{
                                              listview: !gridThird,
                                            }">
                                              <b-row class="el-card" :class="{
                                                'd-none': !checkForValidate(),
                                              }">
                                                <EliminateCategory class="cat-comps" @event="restoreEliminate" v-for="(chart, i) in filtered_barchart &&
                                                  filtered_barchart.filter(
                                                    (item, i) =>
                                                      i > 4 && !item.isActive && common_monthly.includes(item.category)
                                                  )" :key="i" :title="chart.category" :value1="chart.peer_monthly"
                                                  :value2="chart.user_monthly" :frequencyOptions="frequencyOptions" />
                                              </b-row>
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </b-card>
                                <!-- </b-tab> -->
                              </b-col>
                              <b-col sm="12" lg="12" xl="12">
                                <template #title>Other Expenses</template>
                                <b-card no-header no-body
                                  class="category-expenses-card other-xpenses-card no-box-shadow border-radius-10 mb-3">
                                  <div class="category-expenses-card-header">
                                    <h4 class="category-expenses-card-title m-0">
                                      <i class="fas fa-funnel-dollar mr-2"></i>
                                      Other Expenses
                                    </h4>
                                  </div>
                                  <div class="category-expenses-card-body">
                                    <b-row class="el-card" :class="{
                                      'd-none': !checkForValidate(),
                                    }">
                                      <budgetComponent :zip="zip" :age="age" :defaultValues="changedValuesText"
                                        :grid="gridSecond" :showPeer="showPeer" @event="openModelEliminate"
                                        @changeValue="changeValue" :defaultActiveTab="defaultActiveTab"
                                        @defaultActiveTabAction="defaultActiveTabAction" class="cat-comps" v-for="chart in filtered_barchart &&
                                          filtered_barchart.filter(
                                            (item, i) => i > 4 && item.isActive && !common_monthly.includes(item.category)
                                          )" :key="chart.category" :title="chart.category" :value1="chart.peer_monthly"
                                        :value2="chart.user_monthly" :frequencyOptions="frequencyOptions" />
                                    </b-row>
                                    <div class="eliminate-category-accordion accordion-collapsed d-none mt-2"
                                      role="tablist" :class="{
                                        'd-none': !checkForValidate(),
                                      }">
                                      <b-card no-body class="card-shadow border-none">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                          <b-button block @click="visibleDisabledCat = !visibleDisabledCat"
                                            :class="visibleDisabledCat ? null : 'collapsed'"
                                            :aria-expanded="visibleDisabledCat ? 'true' : 'false'"
                                            aria-controls="accordion-rm">
                                            Removed Categories
                                            <span class="ml-1 d-inline-block fw-normal">({{ eleOtherBillCount }})</span>
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-rm" v-model="visibleDisabledCat"
                                          accordion="eliminate-category-accordiona" role="tabpanel">
                                          <b-card-body class="w-100" :class="{ printbg: !isActive }">
                                            <div class="budget-tables w-100" :class="{
                                              listview: !gridThird,
                                            }">
                                              <b-row class="el-card" :class="{
                                                'd-none': !checkForValidate(),
                                              }">
                                                <EliminateCategory class="cat-comps" @event="restoreEliminate" v-for="(chart, i) in filtered_barchart &&
                                                  filtered_barchart.filter(
                                                    (item, i) =>
                                                      i > 4 && !item.isActive && !common_monthly.includes(item.category)
                                                  )" :key="i" :title="chart.category" :value1="chart.peer_monthly"
                                                  :value2="chart.user_monthly" :frequencyOptions="frequencyOptions" />
                                              </b-row>
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </b-card>
                                <!-- </b-tab> -->
                              </b-col>
                            </b-row>
                          </b-container>
                        </div>
                        <!-- </b-tabs> -->
                      </div>
                    </div>
                    <div class="tab-footer d-flex justify-space-between">
                      <button type="button" v-if="!inDemo" class="back-cta" @click="
                        activeTab = ['Income'];
                      scrollToSection('Income');
                      ">
                        <i class="fa fa-arrow-left"></i>
                        Back
                      </button>
                      <button type="button" v-if="!inDemo" class="next-cta" @click="
                        activeTab = ['Your Result'];
                      scrollToSection('Your Result');
                      ">
                        Next
                        <i class="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                  <div id="my-result-page" class="result-page result-not-found-image tab-design position-relative"
                    :class="{
                      'result-not-found': !activeTab.includes('Your Result'),
                    }">
                    <div class="headline-title font-urbanerounded-bold">Results</div>
                    <div class="all_tab_data pb-2">
                      <div id="result-flow-score">
                        <!-- Result Not Found Start -->
                        <b-row :class="{
                          'd-none':
                            checkForValidate() &&
                            monthly_take_home_input_value_check > 1 &&
                            !isNaN(monthly_take_home_input_value_check),
                        }">
                          <b-col md="12" lg="12" xl="12">
                            <b-card no-header
                              class="result-not-fount-card border-0 no-box-shadow border-radius-10 text-center mb-3 h-100">
                              <div class="result-not-fount-image text-center">
                                <img src="imgs/not-found.png" class="img-fluid" />
                              </div>
                            </b-card>
                          </b-col>
                        </b-row>
                        <!-- Result Not Found End -->
                        <b-row :class="{
                          'd-none':
                            !checkForValidate() ||
                            monthly_take_home_input_value_check < 1 ||
                            isNaN(monthly_take_home_input_value_check),
                        }">
                          <b-col md="12" lg="12" xl="5" class="order-0 order-lg-0">
                            <b-card no-header no-body
                              class="budget-health-score-card border-0 no-box-shadow border-radius-10 purple-gradient mb-3">
                              <div class="budget-health-score-card-header">
                                <div class="d-sm-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center mb-3 mb-sm-0">
                                    <h4 class="budget-health-score">Your Budget Health Score</h4>
                                    <div class="hover-info-box ml-2">
                                      <span class="hover-icon ml-2">
                                        <i class="far fa-question-circle text-white"></i>
                                      </span>
                                      <div class="hover-info position-left">
                                        <p class="m-0 hover-info-text">
                                          This is a simple 'grade' of your budget. You want an 80(B) or higher to
                                          consistently be able to grow savings or reduce debt
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="budget-health-score-card-body">
                                <b-row class="align-items-center">
                                  <b-col md="6" lg="5">
                                    <div class="pie-chart-coloumn">
                                      <div class="text-center w-100" :class="{
                                        printbg: !isActive,
                                        'd-none': !scores_ready,
                                      }">
                                        <div id="speedometer"></div>
                                      </div>
                                      <p class="returnScore text-center mb-0">
                                        {{ returnScore }}
                                      </p>
                                      <p class="title is-4 mb-0 abst text-center w-100" v-if="!scores_ready">
                                        <i class="fas fa-cog fa-spin"></i>
                                      </p>
                                    </div>
                                  </b-col>
                                  <b-col md="6" lg="7">
                                    <div class="peers-score-column text-center text-md-left mt-3 mt-md-0">
                                      <div v-if="returnScore >= 80" class="score-info big-font">
                                        <h4 class="font-weight-bold text-white mb-3 mb-lg-4" :class="{
                                          'text-small': returnDefaultTextOnly().descriptiveText === '',
                                        }">
                                          <span class="spendid-gradescore">
                                            {{ returnDefaultTextOnly().mainText }}
                                          </span>
                                        </h4>
                                      </div>
                                      <p class="returnscore mb-0">
                                        Peer's Score =
                                        {{ returnScoreLending }}
                                      </p>
                                    </div>
                                  </b-col>
                                </b-row>
                              </div>
                              <!-- <div class="budget-health-score-card-footer text-center">
                                <b-button v-if="isActive" @click="saveReport()" class="btn-green save_report_btn mx-1"
                                  size="lg">
                                  Save Report
                                </b-button>
                                <b-alert variant="success" class="mt-2" :show="saveReportPopUp">Report Saved</b-alert>
                              </div> -->
                            </b-card>
                          </b-col>
                          <b-col md="12" lg="12" xl="3" class="order-lg-3">
                            <b-row>
                              <b-col cols="12" md="6" xl="12">
                                <b-card no-header no-body
                                  class="no-box-shadow border-0 border-radius-10 grade-card mb-3 your_monthly_saving_ability"
                                  v-bind:class="breakeven_grade_css_classes">
                                  <div class="grade-card-header">
                                    <h4 class="grade-card-title">Monthly Predicted Saving Ability</h4>
                                  </div>
                                  <div class="grade-card-body">
                                    <b-row class="align-items-center">
                                      <b-col xs="7">
                                        <p class="title is-4" v-if="!scores_ready">
                                          <i class="fas fa-cog fa-spin"></i>
                                        </p>
                                        <h4 class="scrore-nummer mb-0" v-else>
                                          {{ lending_score_cash_excess_formatted }}
                                        </h4>
                                      </b-col>
                                      <b-col xs="5">
                                        <h5 class="scrore-nummer mb-0 text-right">You</h5>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-card>
                              </b-col>
                              <b-col cols="12" md="6" xl="12">
                                <b-card no-header no-body
                                  class="no-box-shadow border-0 border-radius-10 grade-card red-gradient mb-3"
                                  v-bind:class="saving_peer_amount_css_classes">
                                  <div class="grade-card-header">
                                    <h4 class="grade-card-title">Monthly Predicted Saving Ability</h4>
                                  </div>
                                  <div class="grade-card-body">
                                    <b-row class="align-items-center">
                                      <b-col xs="7">
                                        <p class="title is-4" v-if="!scores_ready">
                                          <i class="fas fa-cog fa-spin"></i>
                                        </p>
                                        <h4 class="scrore-nummer mb-0" v-else>
                                          {{ saving_peer_amount }}
                                        </h4>
                                      </b-col>
                                      <b-col xs="5">
                                        <h5 class="scrore-nummer mb-0 text-right">Peers</h5>
                                      </b-col>
                                    </b-row>
                                  </div>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col md="12" lg="5" xl="6" class="mb-3 mb-md-4 order-lg-3">
                            <b-card no-header
                              class="projected-investment-header-card no-box-shadow border-radius-10 mb-md-3 h-100">
                              <div class="projected-investment-header">
                                <div class="text-center">
                                  <h4 class="budget-by-category-title d-flex justify-content-between purple_text">
                                    Projected Savings Growth To Age 65
                                    <p class="text-capitalize">(Before Taxes)</p>
                                  </h4>
                                  <h6 class="text-capitalize">at Constant Monthly Saving Amount</h6>
                                </div>
                              </div>
                              <div class="projected-investment-body py-2 py-lg-3">
                                <b-row>
                                  <b-col>
                                    <div id="chartdiv" ref="chartdiv"></div>
                                  </b-col>
                                </b-row>
                                <b-row class="mt-4 align-items-center justify-content-center">
                                  <b-col cols="12" md="12" lg="12" class="text-center">
                                    <div class="investment-return">
                                      <b-row class="align-items-center my-2 my-lg-0">
                                        <b-col cols="12" md="6" lg="6">
                                          <p class="mb-0 font-weight-bold text-md-right flex-shrink-xl-0 mr-sm-3">
                                            Average Annual Return:
                                          </p>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="6">
                                          <!-- Using slots -->
                                          <div
                                            class="d-flex align-items-center justify-content-center justify-content-md-start">
                                            <b-input-group class="investment-return-group w-100px">
                                              <template #append>
                                                <b-input-group-text><strong>%</strong></b-input-group-text>
                                              </template>
                                              <b-form-input v-model="predictGrowth" @change="predictGrowthChange"
                                                type="number" class="big-input-font"></b-form-input>
                                            </b-input-group>
                                            <div class="d-flex align-items-center ml-3">
                                              <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                                              <span class="ml-1">Edit</span>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </b-col>
                                  <b-col cols="12" md="12" lg="12" class="text-center d-none">
                                    <div class="investment-return mt-2">
                                      <b-row class="align-items-center my-2 my-lg-0">
                                        <b-col cols="12" md="6" lg="6">
                                          <p class="mb-0 font-weight-bold text-md-right flex-shrink-xl-0 mr-sm-3">
                                            Current Investment Balance:
                                          </p>
                                        </b-col>
                                        <b-col cols="12" md="6" lg="6">
                                          <!-- Using slots -->
                                          <div
                                            class="d-flex align-items-center justify-content-center justify-content-md-start">
                                            <b-input-group class="investment-return-group w-100px">
                                              <NumberInput class="w-100px" :model="investmentBalance"
                                                @changeValue="numberValueChange2" name="investmentBalance"
                                                placeholder="$0" />
                                            </b-input-group>
                                            <div class="d-flex align-items-center ml-3">
                                              <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                                              <span class="ml-1">Edit</span>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </b-col>
                                </b-row>
                                <!-- <b-row>
                                  <b-col class="text-center mt-3">
                                    <b-button class="btn-green ml-2 xs-mt-2" @click="projectGrowthView(predictGrowth)">
                                      Update
                                    </b-button>
                                  </b-col>
                                </b-row> -->
                              </div>
                            </b-card>
                          </b-col>
                          <b-col md="12" lg="7" xl="6" class="mb-3 mb-md-4 order-lg-4">
                            <b-card no-header
                              class="your-opportunities-card no-box-shadow border-radius-10 mb-md-3 h-100">
                              <div class="your-opportunities-card-header d-sm-flex justify-content-between">
                                <div class="d-flex align-items-center">
                                  <h4 class="your-opportunities-title">Areas For Improvement</h4>
                                  <div class="hover-info-box">
                                    <span class="hover-icon ml-2">
                                      <i class="far fa-question-circle"></i>
                                    </span>
                                    <div class="hover-info position-right">
                                      <p class="m-0 hover-info-text">
                                        Categories where Your amount is higher than Peers
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <p class="more-info text-capitalize font-weight-bold mb-0">
                                  (Click on blue bars below for more info)
                                </p>
                              </div>
                              <div class="your-opportunities-card-body py-2 mt-2">
                                <div class="peer-chart-opportunities" :class="{ 'd-none': !showPeer }" role="tablist">
                                  <b-row :class="{
                                    'd-none': !hideBarChart || !checkForValidate(),
                                  }">
                                    <b-col md="12">
                                      <div class="no-peers">
                                        <div class="no-peers-image text-center">
                                          <img class="img-fluid" alt="logo" src="imgs/opportunities-object.svg" />
                                        </div>
                                        <div class="no-peers-actions mt-2">
                                          <b-button @click="
                                            activeTab = ['Your Major Expenses'];
                                          collapsedChecked = false;
                                          scrollToSection('Your Major Expenses');
                                          " type="button" class="no-peers-btn purple-gradient">
                                            <b-row class="align-items-center">
                                              <b-col sm="9" xl="10">
                                                <span
                                                  class="no-peers-text d-inline-block text-center text-sm-left w-100 mb-3 mb-sm-0">
                                                  Review Expense Categories where your amount is higher than peers
                                                </span>
                                              </b-col>
                                              <b-col sm="3" xl="2">
                                                <span class="arrow-right-btn btn-77 flex-shrink-0 mx-auto ml-sm-auto">
                                                  <i class="fas fa-arrow-right"></i>
                                                </span>
                                              </b-col>
                                            </b-row>
                                          </b-button>
                                        </div>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row :class="{
                                    'd-none': hideBarChart,
                                  }">
                                    <b-col>
                                      <!-- Chart Box Area Start -->
                                      <div class="your-opportunities-bars-process mt-3">
                                        <div id="barchart" ref="barchart" class="rm-chart-watermark"></div>
                                      </div>
                                      <!-- Chart Box Area End -->
                                    </b-col>
                                  </b-row>
                                </div>
                              </div>
                            </b-card>
                          </b-col>
                          <b-col md="12" lg="12" xl="4" class="mb-3 mb-md-4 order-lg-2">
                            <b-card no-header
                              class="budget-by-category-card no-box-shadow border-radius-10 mb-md-3 h-100">
                              <div class="budget-by-category-card-header">
                                <div class="d-flex align-items-center">
                                  <h4 class="budget-by-category-title">Budget By Category</h4>
                                  <div class="hover-info-box">
                                    <span class="hover-icon ml-2">
                                      <i class="far fa-question-circle"></i>
                                    </span>
                                    <div class="hover-info position-left">
                                      <p class="m-0 hover-info-text">Pie chart breakdown of your categorized budget</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="budget-by-category-card-body py-3">
                                <div class="chart-box text-center w-100">
                                  <div id="piechart" ref="piechart" :class="{ 'd-none': !checkForValidate() }"></div>
                                </div>
                              </div>
                              <div
                                class="budget-by-category-card-action text-center mt-2 d-flex justify-content-center">
                                <b-button @click="instantReport()" type="button"
                                  class="btn-purple btn-77 your-budget-analysis save_report_btn btn-lg">
                                  Your Budget Analysis & Next Steps
                                </b-button>
                              </div>
                              <div class="mt-3 text-center w-100">
                                <b-button @click="downloadCSV(false)" type="button" id="export-csv-file"
                                  class="btn-green btn-77 export-csv-file save_report_btn btn-lg mx-auto d-none d-md-block">
                                  Export Data To .CSV File
                                </b-button>
                                <b-button @click="downloadCSV(true)" type="button" id="mail-csv-file"
                                  class="btn-green btn-77 send-csv-mail save_report_btn btn-lg mx-auto mt-4 d-block d-md-none">
                                  Export Data To Email
                                </b-button>
                                <b-form-input placeholder="Enter Email" v-model="senderEmail" type="text"
                                  autocomplete="on"
                                  class="position-relative pr-30 hight50 d-block d-md-none mt-3"></b-form-input>
                              </div>
                            </b-card>
                          </b-col>
                        </b-row>
                        <b-row :class="{
                          'd-none':
                            !checkForValidate() ||
                            monthly_take_home_input_value_check < 1 ||
                            isNaN(monthly_take_home_input_value_check),
                        }">
                          <b-col cols="12" md="3" lg="4" xl="4" class="mb-3">
                            <b-card no-header
                              class="edit-budget-category-card blue-gradient no-box-shadow border-0 border-radius-10 text-center mb-md-3 h-100">
                              <div class="d-flex flex-column align-items-center justify-content-center h-100">
                                <div class="edit-expense-icon mt-xl-3 text-center d-none d-md-block">
                                  <img class="img-fluid" alt="logo" src="imgs/edit-budget-icon.svg" />
                                </div>
                                <div class="edit-expense-text mb-3 my-md-3 my-xl-5 text-center">
                                  <h4 class="edit-expense-text-info m-0 px-xl-4">Edit Your Expense Amounts</h4>
                                </div>
                                <div clas="edit-expense-action">
                                  <b-button @click="
                                    activeTab = ['Your Major Expenses'];
                                  collapsedChecked = false;
                                  scrollToSection('Your Major Expenses');
                                  " type="button" class="edit-expense-action-btn btn-77">
                                    <i class="fas fa-pencil-alt"></i>
                                  </b-button>
                                </div>
                              </div>
                            </b-card>
                          </b-col>
                          <b-col cols="12" md="9" lg="8" xl="8" class="mb-3">
                            <b-card no-header
                              class="budget-modal-category-card no-box-shadow border-radius-10 mb-md-3 h-100">
                              <div class="budget-modal-category-card-header">
                                <div class="d-flex align-items-center">
                                  <h4 class="your-opportunities-title">Your Budget Model</h4>

                                  <div class="hover-info-box">
                                    <span class="hover-icon ml-2">
                                      <i class="far fa-question-circle"></i>
                                    </span>
                                    <div class="hover-info position-left">
                                      <h5 class="hover-info-title fw-700">What is 50-30-20 Budget Modeling?</h5>
                                      <h5 class="hover-info-subtitle">
                                        Here’s a quick breakdown of how a few common expenses are divided among three
                                        major categories.
                                      </h5>

                                      <p class="mb-1">
                                        <b>50% Toward Needs</b>
                                      </p>
                                      <h5 class="hover-info-subtitle">
                                        This approach states that you should budget 50% of your take-home income on
                                        necessary items, such as housing, transportation, and other bills.
                                      </h5>
                                      <h5 class="hover-info-subtitle mb-2">
                                        The items in this category cover the basics of life. Here are the most common
                                        “needs” included:
                                      </h5>

                                      <ul class="innerlist">
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Housing.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Transportation,</b>
                                            including car payments and gas.
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Utilities,</b>
                                            like your cell phone, heat, water, gas and trash.
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Groceries</b>
                                            (but not eating out in restaurants).
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Insurance premiums,</b>
                                            such as life insurance, health insurance and auto insurance.
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Medical bills.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Childcare.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Basic clothing.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Minimum payments</b>
                                            on your debt, such as credit cards, student loans, etc.
                                          </h5>
                                        </li>
                                      </ul>
                                      <p class="mb-1">
                                        <b>30% Toward Wants</b>
                                      </p>
                                      <h5 class="hover-info-subtitle">
                                        This is what some people think of as the “fun” category. It includes things you
                                        want but could certainly live without if you had to.
                                      </h5>
                                      <h5 class="hover-info-subtitle mb-2">
                                        Here are some of the common expenses that get classified as “wants”:
                                      </h5>

                                      <ul class="innerlist">
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Date nights.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Eating out.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Entertainment</b>
                                            (concerts, plays, sporting events, etc.).
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Gym membership.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Hobbies.</b>
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Premium and streaming TV</b>
                                            (like HBO and Netflix).
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Non-essential shopping</b>
                                            (new golf clubs, a new Kate Spade purse, etc.).
                                          </h5>
                                        </li>
                                        <li>
                                          <h5 class="hover-info-subtitle">
                                            <b>Travel.</b>
                                          </h5>
                                        </li>
                                      </ul>
                                      <p class="mb-1">
                                        <b>20% Toward Savings</b>
                                      </p>
                                      <h5 class="hover-info-subtitle">
                                        The next number to think about in this budget formula is 20%. This is the money
                                        that goes toward achieving your financial goals, which may include:
                                      </h5>

                                      <ul class="innerlist">
                                        <li>
                                          <a
                                            href="https://www.thewaystowealth.com/save-money/how-to-build-an-emergency-fund/">
                                            Building an emergency fund.
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.thewaystowealth.com/debt-payoff/get-out-of-debt-fast/">
                                            Paying off high-interest debt.
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="budget-modal-category-card-body mt-xl-3">
                                <b-row>
                                  <b-col cols="4" sm="4" md="4" xl="4">
                                    <div class="modal-piechart mt-3 mt-lg-4 w-100" :class="{
                                      printbg: !isActive,
                                    }">
                                      <b-card no-body
                                        class="modal-piechart-card no-box-shadow border-0 border-radius-10" :class="{
                                          printbg: !isActive,
                                        }">
                                        <b-card-header header-tag="header" class="border-none shadow-none p-0 w-100"
                                          role="tab" :class="{
                                            printbg: !isActive,
                                          }">
                                          <b-button block variant="light" class="cursor-auto">Model</b-button>
                                        </b-card-header>
                                        <b-card-body class="px-1 w-100" :class="{
                                          printbg: !isActive,
                                        }">
                                          <div class="chart-box d-block text-center">
                                            <div class="w-100 text-center">
                                              <div id="piechart5" ref="piechart5" class="rm-chart-watermark"></div>
                                            </div>
                                          </div>
                                        </b-card-body>
                                      </b-card>
                                    </div>
                                  </b-col>
                                  <b-col cols="4" sm="4" md="4" xl="4">
                                    <div class="modal-piechart mt-3 mt-lg-4 w-100" :class="{
                                      printbg: !isActive,
                                    }">
                                      <b-card no-body
                                        class="modal-piechart-card no-box-shadow border-0 border-radius-10" :class="{
                                          printbg: !isActive,
                                        }">
                                        <b-card-header header-tag="header" class="border-none shadow-none p-0 w-100"
                                          :class="{
                                            printbg: !isActive,
                                          }" role="tab">
                                          <b-button block variant="light" class="cursor-auto">Your Peers</b-button>
                                        </b-card-header>
                                        <b-card-body class="px-1 w-100" :class="{
                                          printbg: !isActive,
                                        }">
                                          <div class="chart-box d-block text-center">
                                            <div class="w-100 text-center">
                                              <div id="piechart4" ref="piechart4" class="rm-chart-watermark"></div>
                                            </div>
                                          </div>
                                        </b-card-body>
                                      </b-card>
                                    </div>
                                  </b-col>
                                  <b-col cols="4" sm="4" md="4" xl="4">
                                    <div class="modal-piechart mt-3 mt-lg-4 w-100" :class="{
                                      printbg: !isActive,
                                    }">
                                      <b-card no-body
                                        class="modal-piechart-card no-box-shadow border-0 border-radius-10" :class="{
                                          printbg: !isActive,
                                        }">
                                        <b-card-header header-tag="header" class="border-none shadow-none p-0 w-100"
                                          role="tab" :class="{
                                            printbg: !isActive,
                                          }">
                                          <b-button block variant="light" class="cursor-auto">You</b-button>
                                        </b-card-header>
                                        <b-card-body class="px-1 w-100" :class="{
                                          printbg: !isActive,
                                        }">
                                          <div class="chart-box d-block text-center">
                                            <div class="w-100 text-center">
                                              <div id="piechart3" ref="piechart3" class="rm-chart-watermark"></div>
                                            </div>
                                          </div>
                                        </b-card-body>
                                      </b-card>
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row class="mt-3 mt-lg-4">
                                  <b-col sm="12" xl="12">
                                    <div class="budget-plan-btn">
                                      <p>
                                        <span class="needs_goals"></span>
                                        Needs
                                      </p>
                                      <p>
                                        <span class="wants_goals"></span>
                                        Wants
                                      </p>
                                      <p>
                                        <span class="financial_goals"></span>
                                        Financial Goals
                                      </p>
                                    </div>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-card>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="how-to-page" :class="{ 'd-none': !activeTab.includes('How To') }">
                  <b-container fluid ref="third_sec" class="custom-container">
                    <howto />
                  </b-container>
                </div>
              </div>
              <b-modal id="eliminated" size="small" ref="eliminated" hide-footer title="Disable Category">
                <div class="mb-4 d-block text-center">
                  <i class="fas fa-exclamation-circle text-warning fa-3x"></i>
                </div>
                <div class="my-4 d-block text-center">
                  <h4 class="font-weight-bold">Are you sure?</h4>
                </div>
                <div class="my-4 d-block text-center">
                  <b-button type="button" @click="runElimination()" variant="info">Removed Category</b-button>
                </div>
                <div class="bg-light border rounded mt-3 py-2 px-3">
                  <h6 class="font-weight-bold">Note</h6>
                  <p class="small m-0">You can restore this category at the bottom of the page anytime</p>
                </div>
              </b-modal>
            </section>
          </b-form>
        </div>
      </div>
    </div>
    <!-- <b-modal ref="logout-popup" hide-footer hide-header id="logout-popup" header-text-variant="light"
      header-border-variant="none">
      <b-row>
        <b-col>
          <h4 class="mt-4 mb-3 text-center">Automatically logged out due to 15 minutes of inactivity</h4>
          <b-button class="btn btn-success green-btn w-100 btnheight50" @click="pageReload">Login</b-button>
        </b-col>
      </b-row>
    </b-modal> -->
    <!-- <b-modal ref="email-popup" hide-footer id="emailpopup" header-text-variant="light" header-border-variant="none">
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img src="footer-logo.png" alt="" />
            <h4 class="mt-4 mb-3">Login</h4>
          </b-col>
          <b-form-group class="has-icons-right text-center">
            <b-col class="d-flex align-items-center">
              <b-form-input placeholder="Enter Email" v-model="user_email" type="text" autocomplete="on"
                class="position-relative pr-30 hight50"></b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)" class="fas fa-times text-danger"></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>
          <b-form-group class="has-icons-right text-center">
            <b-col class="d-flex align-items-center">
              <b-form-input placeholder="Enter Password" v-model="user_password" type="password" autocomplete="on"
                class="position-relative pr-30 hight50"></b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i v-if="user_password.length <= 6" class="fas fa-times text-danger"></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>
          <b-form-group class="text-center mt-2">
            <b-col class="d-flex align-items-center">
              <b-button class="btn btn-success green-btn w-100 btnheight50" @click="verifyEmail()"
                :disabled="!(user_password.length <= 6) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)"
                aria-controls="cust-core-expense-1">
                Login
              </b-button>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal> -->
    <b-modal id="chatGptList" v-model="modalShow" scrollable size="xl" content-class="get-advice-modal"
      v-if="modalShow == true" hide-footer>
      <ChatGptList :uses="uses" />
    </b-modal>
    <b-modal ref="other-debt" scrollable hide-footer size="xl" content-class="other-debt-modal">
      <b-card no-header class="no-box-shadow other-debt-payments-inner-card border-radius-10">
        <b-row>
          <b-col md="12" lg="12">
            <b-card no-header no-body class="no-box-shadow monthly-payment-card border-radius-10">
              <div class="monthly-payment-card-header">
                <h4 class="monthly-payment-card-title">Enter Monthly Payment Amounts For</h4>
              </div>
              <div class="monthly-payment-card-body">
                <h3 class="monthly-payment-hd text-right mb-3 mb-lg-4">Monthly Payment</h3>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Past Credit Card Debt</h4>
                      <p class="monthly-payment-label-desc">Exclude New Monthly Charges You Pay In Full Each Month</p>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="creditDebtPayment" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Student Loans</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="studentLoan" v-money="money" type="text" pattern="\d*" autocomplete="on"
                        class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Home Equity Line of Credit</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="homeEquityPayment" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Alimony or Child Support</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="alimonyPayments" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Medical Debt Payments</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="childSupportPayments" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Estimated Tax Payments</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="estimatedTaxPayments" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="my-0 my-md-2">
                  <b-col md="8">
                    <div class="monthly-payment-form-labels mb-2 mb-lg-1">
                      <h4 class="monthly-payment-label">Other</h4>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <b-form-input v-model="otherDebtPayments" v-money="money" type="text" pattern="\d*"
                        autocomplete="on" class="text-right position-relative big-input-font" placeholder="$0" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="monthly-payment-card-footer text-right">
                <span class="total-amount-lavel mr-4">Total</span>
                <span class="total-amounts">
                  {{ otherAllDebs }}
                </span>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="text-center position-relative">
            <b-button type="button" class="btn-green" @click="submitDebt">OK & Continue</b-button>
            <div class="dbt-peer-amount d-inline-block">
              <p class="m-0 d-inine-flex align-items-center">
                <span>Peer Amount =</span>
                {{ returnDebtPeer }}
              </p>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
  </div>
</template>

<style src="./landing.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
